import gql from 'graphql-tag'
import type * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from 'legacy/apollo/codegenReactApolloHooks'
export type Maybe<T> = T
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: string
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any
  /** An ISO 8601-encoded date */
  ISO8601Date: any
  Time: string
  /** A valid URL, transported as a string */
  Url: any
  True: true
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any
  LegacyDate: any
}

export type AccessControlAuthorizationAuthorizationCheck = {
  __typename?: 'AccessControlAuthorizationAuthorizationCheck'
  /** Determines whether the current account has access to the given rules */
  authorized: Scalars['Boolean']
}

export type AccessControlConfiguration = {
  __typename?: 'AccessControlConfiguration'
  /** The flippers associated with the account */
  flippers: AccessControlFlippers
  /** The policies associated with the account */
  policies: AccessControlPolicies
  /** The access control details for the retailer */
  retailerDetails: AccessControlRetailerDetails
}

export type AccessControlConfigurationRetailerDetailsArgs = {
  retailerId: Scalars['ID']
}

export type AccessControlFlippers = {
  __typename?: 'AccessControlFlippers'
  /** The modernized version of the enterprise dashboard nav */
  modernNavigation: Scalars['Boolean']
}

export type AccessControlPolicies = {
  __typename?: 'AccessControlPolicies'
  /** Permission to view the admin tools section */
  viewAdminToolsSection: Scalars['Boolean']
  /** Permission to view the retailer dashboard section */
  viewRetailerDashboardSection: Scalars['Boolean']
}

export type AccessControlRetailerDetails = {
  __typename?: 'AccessControlRetailerDetails'
  /** The policies associated with the retailer */
  policies: AccessControlRetailerPolicies
}

export type AccessControlRetailerPolicies = {
  __typename?: 'AccessControlRetailerPolicies'
  /** Permission to modify retailer location groups */
  modifyRetailerLocationGroups: Scalars['Boolean']
  /** Permission to modify retailer reports */
  modifyRetailerReports: Scalars['Boolean']
  /** Permission to view retailer location groups */
  viewRetailerLocationGroups: Scalars['Boolean']
  /** Permission to view retailer reports */
  viewRetailerReports: Scalars['Boolean']
}

export type AccessToken = {
  __typename?: 'AccessToken'
  /** The account associated with the token */
  enterpriseAccount: Maybe<EnterpriseAccount>
  /** A unique token for authentication purposes */
  token: Scalars['ID']
}

export type Aisle = {
  __typename?: 'Aisle'
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  departmentId: Maybe<Scalars['BigInt']>
}

export type ApiSetting = {
  __typename?: 'ApiSetting'
  id: Maybe<Scalars['BigInt']>
  partnerId: Maybe<Scalars['BigInt']>
  apiType: Maybe<Scalars['String']>
  cron: Maybe<Scalars['String']>
  integrationType: Maybe<Scalars['String']>
  enabled: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
}

/** The method of authentication associated with an account */
export type AuthenticationInterface = {
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID']
}

export type Banner = {
  __typename?: 'Banner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  imageMobileUrl: Maybe<Scalars['String']>
  imageAltText: Maybe<Scalars['String']>
  status: Maybe<Status>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  action: Maybe<Scalars['String']>
  actionData: Maybe<Scalars['String']>
  tagline: Maybe<Scalars['String']>
  taglineColorHex: Maybe<Scalars['String']>
  buttonStyle: Maybe<ButtonStyle>
  ctaAction: Maybe<BannerAction>
  locale: Maybe<InstacartCustomersSharedV1Locale>
}

export type BannerAction = {
  __typename?: 'BannerAction'
  navigateToUrl: Maybe<NavigateToUrl>
  navigateToStorefront: Maybe<NavigateToStorefront>
  navigateToStoreselector: Maybe<NavigateToStoreSelector>
  navigateToPickupStoreselector: Maybe<NavigateToPickupStoreSelector>
  navigateToContainerPathViaStoreselector: Maybe<NavigateToContainerPathViaStoreSelector>
  navigateToDepartment: Maybe<NavigateToDepartment>
  navigateToProduct: Maybe<NavigateToProduct>
  doNotNavigate: Maybe<DoNotNavigate>
  navigateToCategorySurface: Maybe<NavigateToCategorySurface>
  navigateToRetailerCollection: Maybe<NavigateToRetailerCollection>
  navigateToRetailerCollectionViaStoreselector: Maybe<NavigateToRetailerCollectionViaStoreSelector>
  navigateToPromoModal: Maybe<NavigateToPromoModal>
  navigateToCollection: Maybe<NavigateToCollection>
  navigateToSsaStoreselector: Maybe<NavigateToSsaStoreSelector>
  navigateToCollectionHub: Maybe<NavigateToCollectionHub>
}

export type BannerActionInput = {
  navigateToUrl?: Maybe<NavigateToUrlInput>
  navigateToStorefront?: Maybe<NavigateToStorefrontInput>
  navigateToStoreselector?: Maybe<NavigateToStoreSelectorInput>
  navigateToPickupStoreselector?: Maybe<NavigateToPickupStoreSelectorInput>
  navigateToContainerPathViaStoreselector?: Maybe<NavigateToContainerPathViaStoreSelectorInput>
  navigateToDepartment?: Maybe<NavigateToDepartmentInput>
  navigateToProduct?: Maybe<NavigateToProductInput>
  doNotNavigate?: Maybe<DoNotNavigateInput>
  navigateToCategorySurface?: Maybe<NavigateToCategorySurfaceInput>
  navigateToRetailerCollection?: Maybe<NavigateToRetailerCollectionInput>
  navigateToRetailerCollectionViaStoreselector?: Maybe<NavigateToRetailerCollectionViaStoreSelectorInput>
  navigateToPromoModal?: Maybe<NavigateToPromoModalInput>
  navigateToCollection?: Maybe<NavigateToCollectionInput>
  navigateToSsaStoreselector?: Maybe<NavigateToSsaStoreSelectorInput>
  navigateToCollectionHub?: Maybe<NavigateToCollectionHubInput>
}

export type BannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  imageMobileUrl?: Maybe<Scalars['String']>
  imageAltText?: Maybe<Scalars['String']>
  status?: Maybe<Status>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  action?: Maybe<Scalars['String']>
  actionData?: Maybe<Scalars['String']>
  tagline?: Maybe<Scalars['String']>
  taglineColorHex?: Maybe<Scalars['String']>
  buttonStyle?: Maybe<ButtonStyle>
  ctaAction?: Maybe<BannerActionInput>
  locale?: Maybe<InstacartCustomersSharedV1Locale>
}

export enum BannerLocaleEnum {
  /** American English */
  EnUs = 'EN_US',
  /** Canadian English */
  EnCa = 'EN_CA',
  /** Canadian French */
  FrCa = 'FR_CA',
}

export type BannerType = {
  __typename?: 'BannerType'
  defaultBanner: Maybe<Banner>
  textWithThumbnail: Maybe<TextWithThumbnail>
  imageForward: Maybe<ImageForward>
  logoWithTextBanner: Maybe<LogoWithTextBanner>
  unknownBanner: Maybe<UnknownBanner>
  textWithThumbnailFlex: Maybe<TextWithThumbnailFlex>
  imageForwardFlex: Maybe<ImageForwardFlex>
  heroBanner: Maybe<HeroBanner>
  secondaryBanner: Maybe<SecondaryBanner>
}

export type BannerTypeInput = {
  defaultBanner?: Maybe<BannerInput>
  textWithThumbnail?: Maybe<TextWithThumbnailInput>
  imageForward?: Maybe<ImageForwardInput>
  logoWithTextBanner?: Maybe<LogoWithTextBannerInput>
  unknownBanner?: Maybe<UnknownBannerInput>
  textWithThumbnailFlex?: Maybe<TextWithThumbnailFlexInput>
  imageForwardFlex?: Maybe<ImageForwardFlexInput>
  heroBanner?: Maybe<HeroBannerInput>
  secondaryBanner?: Maybe<SecondaryBannerInput>
}

export enum BannerVariant {
  Image = 'IMAGE',
  Text = 'TEXT',
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  Large = 'LARGE',
  ImageForward = 'IMAGE_FORWARD',
  LogoWithText = 'LOGO_WITH_TEXT',
  AsyncImage = 'ASYNC_IMAGE',
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  HeroBanner = 'HERO_BANNER',
  SecondaryBanner = 'SECONDARY_BANNER',
}

export enum ButtonStyle {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export enum ButtonVariantEnum {
  /** Use the primary button style */
  Primary = 'PRIMARY',
}

export type CallbackConfigurationInput = {
  /** The id */
  id: Scalars['ID']
  /** The authentication URI */
  authUri?: Maybe<Scalars['String']>
  /** The client id */
  credentialsClientId?: Maybe<Scalars['String']>
  /** The client id */
  credentialsClientSecret?: Maybe<Scalars['String']>
  /** The callback URI */
  callbackUri?: Maybe<Scalars['String']>
  /** The access token TTL */
  accessTokenTtl?: Maybe<Scalars['Int']>
  /** The enabled statusers */
  statusesOfInterest?: Maybe<Array<Scalars['String']>>
  /** The possible statuses to enable */
  availableStatuses?: Maybe<Array<Scalars['String']>>
}

export type CancelOrderRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  userId?: Maybe<Scalars['BigInt']>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
}

export type CancelOrderResponse = {
  __typename?: 'CancelOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>
}

export type CatalogAisle = {
  __typename?: 'CatalogAisle'
  /** The department associated with this aisle */
  department: CatalogDepartment
  /** A unique identifier for the aisle */
  id: Scalars['ID']
  /** The aisle's name - ('Candy & Chocolates', 'Chips & Pretzels', ...) */
  name: Scalars['String']
}

export type CatalogChangesetNewProductRequest = {
  __typename?: 'CatalogChangesetNewProductRequest'
  /** The aisle for the product - `Candy & Chocolate` */
  aisle: CatalogAisle
  /** Is the product alcoholic? - (true, false) */
  alcoholic: Scalars['Boolean']
  /** The product's brand - `Hershey's` */
  brand: Scalars['String']
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /** The cost unit of the product - (`each`, `lb`, ...) */
  costUnit: CostUnitEnum
  /** When the changeset product was created */
  createdAt: Scalars['Time']
  /** The department for the product - `Snacks` */
  department: CatalogDepartment
  /** Details about the product, e.g. `Brown, overripe bananas, suitable for baking` */
  description: Scalars['String']
  /** Is the product fat_free? - (true, false) */
  fatFree: Scalars['Boolean']
  /** Is the product gluten_free? - (true, false) */
  glutenFree: Scalars['Boolean']
  /** A unique identifier for the catalog changeset new product request */
  id: Scalars['ID']
  /** An absolute url representing the 'back' angle - `https://www.example.com/etc` */
  imageUrlBack: Maybe<Scalars['Url']>
  /** An absolute url representing the 'drug facts' angle - `https://www.example.com/etc` */
  imageUrlDrugFacts: Maybe<Scalars['Url']>
  /** An absolute url representing the 'ingredients' angle - `https://www.example.com/etc` */
  imageUrlIngredients: Maybe<Scalars['Url']>
  /** An absolute url representing the 'left' angle - `https://www.example.com/etc` */
  imageUrlLeft: Maybe<Scalars['Url']>
  /** An absolute url representing the 'lifestyle' angle - `https://www.example.com/etc` */
  imageUrlLifestyle: Maybe<Scalars['Url']>
  /** An absolute url representing the 'nutrition' angle - `https://www.example.com/etc` */
  imageUrlNutrition: Maybe<Scalars['Url']>
  /** An absolute url representing the 'primary' angle - `https://www.example.com/etc` */
  imageUrlPrimary: Scalars['Url']
  /** An absolute url representing the 'right' angle - `https://www.example.com/etc` */
  imageUrlRight: Maybe<Scalars['Url']>
  /** An absolute url representing the 'supplement facts' angle - `https://www.example.com/etc` */
  imageUrlSupplementFacts: Maybe<Scalars['Url']>
  /** An absolute url representing the 'top' angle - `https://www.example.com/etc` */
  imageUrlTop: Maybe<Scalars['Url']>
  /** The code-lookup associated with this new product request */
  importProcessCodeLookup: CatalogImportProcessCodeLookup
  /** The id for the code-lookup associated with this new product request */
  importProcessCodeLookupId: Scalars['ID']
  /** Is the product kosher? - (true, false) */
  kosher: Scalars['Boolean']
  /** Is the product low_fat? - (true, false) */
  lowFat: Scalars['Boolean']
  /** The product's name - `Hershey's Extra Large Chocolate Bar` */
  name: Scalars['String']
  /** Is the product organic? - (true, false) */
  organic: Scalars['Boolean']
  /** The price per cost unit of the product - `17.9` */
  pricePerCostUnit: Scalars['Float']
  /** The size of the product - (`12 kg`, `14 oz`, ...) */
  size: Scalars['String']
  /** Is the product sugar_free? - (true, false) */
  sugarFree: Scalars['Boolean']
  /** Is the product taxable? - (true, false) */
  taxable: Scalars['Boolean']
  /** When the changeset product was last updated */
  updatedAt: Scalars['Time']
  /** Is the product vegan? - (true, false) */
  vegan: Scalars['Boolean']
  /** Is the product vegetarian? - (true, false) */
  vegetarian: Scalars['Boolean']
}

/** The connection type for CatalogChangesetNewProductRequest. */
export type CatalogChangesetNewProductRequestConnection = {
  __typename?: 'CatalogChangesetNewProductRequestConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogChangesetNewProductRequestEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogChangesetNewProductRequest>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogChangesetNewProductRequestEdge = {
  __typename?: 'CatalogChangesetNewProductRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogChangesetNewProductRequest>
}

export type CatalogChangesetProduct = {
  __typename?: 'CatalogChangesetProduct'
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /** When the changeset product was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog changeset product */
  id: Scalars['ID']
  /** The actual global product associated with this changeset product */
  product: CatalogProduct
  /** The aisle for the changeset product - 'Candy & Chocolate' */
  specifiedAisle: Maybe<CatalogAisle>
  /** The cost unit of the changeset product - ('each','lb', ...) */
  specifiedCostUnit: Maybe<CostUnitEnum>
  /** The department for the changeset product - 'Snacks' */
  specifiedDepartment: Maybe<CatalogDepartment>
  /** The price per cost unit of the changeset product - '17.9' */
  specifiedPricePerCostUnit: Maybe<Scalars['Float']>
  /** The form-details status of the changeset product - (completed_info, missing_info) */
  status: ChangesetProductStatusEnum
  /** When the changeset product was last updated */
  updatedAt: Scalars['Time']
}

/** The connection type for CatalogChangesetProduct. */
export type CatalogChangesetProductConnection = {
  __typename?: 'CatalogChangesetProductConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogChangesetProductEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogChangesetProduct>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogChangesetProductEdge = {
  __typename?: 'CatalogChangesetProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogChangesetProduct>
}

export type CatalogClassificationInfo = {
  __typename?: 'CatalogClassificationInfo'
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String']
  /** The associated retailer (for in-house products) */
  retailer: Maybe<Retailer>
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum
}

export type CatalogCodeLookup = {
  __typename?: 'CatalogCodeLookup'
  /** The code-lookup's code - (UPC, PLU, etc. - 034000170388) */
  code: Scalars['String']
  /** The batch with the code-lookup */
  codeLookupBatch: CatalogCodeLookupBatch
  /** The state of the code-lookup - ('PENDING', 'IN_PROGRESS', ...) */
  codeLookupState: CodeLookupStateEnum
  /** The status of the code-lookup - ('NO_MATCHES', 'PERFECT_MATCH', ...) */
  codeLookupStatus: Maybe<CodeLookupStatusEnum>
  /** The type of the code-lookup - ('UPC', 'RRC') */
  codeLookupType: Maybe<CodeLookupTypeEnum>
  /** When the code-lookup was created */
  createdAt: Scalars['Time']
  /** A unique identifier */
  id: Scalars['ID']
  /** An array of product_ids's matching the provided code - (123, 456, ...). */
  productIds: Maybe<Array<Scalars['ID']>>
  /** When the code-lookup was last updated */
  updatedAt: Scalars['Time']
}

export type CatalogCodeLookupBatch = {
  __typename?: 'CatalogCodeLookupBatch'
  /** The owner of the code lookup batch */
  codeLookupBatchOwner: EnterpriseAccount
  /** Wheather all the code lookups in this batch were processed or not */
  codeLookupProcessCompleted: Scalars['Boolean']
  /** List of code lookups that are part of this batch */
  codeLookups: Array<CatalogCodeLookup>
  /** When the code lookup batch was created */
  createdAt: Scalars['Time']
  /** A unique identifier */
  id: Scalars['ID']
  /** The number of code lookups in this batch that perfectly matched with one product */
  perfectMatchCount: Scalars['Int']
  /** Product IDs that perfectly matched with one of the code lookup */
  perfectMatchProductIds: Array<Scalars['ID']>
  /** When the code lookup batch was last updated */
  updatedAt: Scalars['Time']
}

/** Autogenerated return type of CatalogCodeLookupBatchCreate */
export type CatalogCodeLookupBatchCreatePayload = {
  __typename?: 'CatalogCodeLookupBatchCreatePayload'
  /** The newly created code lookup batch */
  catalogCodeLookupBatch: CatalogCodeLookupBatch
}

/** The connection type for CatalogCodeLookup. */
export type CatalogCodeLookupConnection = {
  __typename?: 'CatalogCodeLookupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogCodeLookupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogCodeLookup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogCodeLookupEdge = {
  __typename?: 'CatalogCodeLookupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogCodeLookup>
}

export type CatalogDepartment = {
  __typename?: 'CatalogDepartment'
  /** An array of the department's aisles */
  aisles: Array<CatalogAisle>
  /** A unique identifier for the department */
  id: Scalars['ID']
  /** The department's name - ('Snacks', 'Meat & Seafood', ...) */
  name: Scalars['String']
}

export type CatalogImportProcess = {
  __typename?: 'CatalogImportProcess'
  /** When the import process was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog import process */
  id: Scalars['ID']
  /** The owner of the import process */
  importProcessOwner: EnterpriseAccount
  /** The state of the import process */
  importProcessState: ImportProcessStateEnum
  /** The type of the import process */
  importProcessType: ImportProcessTypeEnum
  /** Description or URL of the data source for this import process */
  source: Maybe<Scalars['String']>
  /** When the import process was last updated */
  updatedAt: Scalars['Time']
  /** The workflow associated with the import process */
  workflow: CatalogWorkflow
}

export type CatalogImportProcessCodeLookup = {
  __typename?: 'CatalogImportProcessCodeLookup'
  /** The code-lookup's code - (UPC, PLU, etc. - 034000170388) */
  code: Scalars['String']
  /** When the code-lookup was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog workflow */
  id: Scalars['ID']
  /** The import process associated with the code-lookup */
  importProcess: CatalogImportProcess
  /** The state of the code-lookup - ('PENDING', 'IN_PROGRESS', ...) */
  importProcessCodeLookupState: ImportProcessCodeLookupStateEnum
  /** The status of the code-lookup - ('NO_MATCHES', 'PERFECT_MATCH', ...) */
  importProcessCodeLookupStatus: Maybe<ImportProcessCodeLookupStatusEnum>
  /** The type of the code-lookup - ('UPC', ...) */
  importProcessCodeLookupType: ImportProcessCodeLookupTypeEnum
  /** An array of product_ids's matching the provided code - (123, 456, ...). */
  productIds: Maybe<Array<Scalars['ID']>>
  /** When the code-lookup was last updated */
  updatedAt: Scalars['Time']
}

/** The connection type for CatalogImportProcessCodeLookup. */
export type CatalogImportProcessCodeLookupConnection = {
  __typename?: 'CatalogImportProcessCodeLookupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogImportProcessCodeLookupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogImportProcessCodeLookup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CatalogImportProcessCodeLookupCreate */
export type CatalogImportProcessCodeLookupCreatePayload = {
  __typename?: 'CatalogImportProcessCodeLookupCreatePayload'
  /** The newly created import process */
  catalogImportProcess: CatalogImportProcess
}

/** An edge in a connection. */
export type CatalogImportProcessCodeLookupEdge = {
  __typename?: 'CatalogImportProcessCodeLookupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogImportProcessCodeLookup>
}

/** The connection type for CatalogImportProcess. */
export type CatalogImportProcessConnection = {
  __typename?: 'CatalogImportProcessConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogImportProcessEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogImportProcess>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogImportProcessEdge = {
  __typename?: 'CatalogImportProcessEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogImportProcess>
}

export type CatalogProduct = {
  __typename?: 'CatalogProduct'
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /**
   * The classified code associated with the product (Also referred to as UPC - '034000170388')
   * @deprecated Use `classification info` instead, as it has more details than `classified_code`
   */
  classifiedCode: Maybe<Scalars['String']>
  /** Details about the product, e.g. 'Brown, overripe bananas, suitable for baking */
  description: Maybe<Scalars['String']>
  /** The product's name - 'Hershey's Extra Large Chocolate Bar' */
  displayName: Scalars['String']
  /** A unique identifier for the product */
  id: Scalars['ID']
  /**
   * The product's name - 'Hershey's Extra Large Chocolate Bar'
   * @deprecated Use `display name` instead, as it has more details than `name`
   */
  name: Scalars['String']
  /** An absolute url of the primary image associated with the product - 'https://www.example.com/etc' */
  primaryImageUrl: Maybe<Scalars['String']>
}

export type CatalogRetailerProduct = {
  __typename?: 'CatalogRetailerProduct'
  /** The available item count of the retailer product */
  availableItemsCount: Maybe<Scalars['Int']>
  /** The details of the retailer product */
  details: Maybe<Scalars['String']>
  /** The display_name of the retailer product */
  displayName: Maybe<Scalars['String']>
  /** A unique identifier for the retailer product */
  id: Scalars['ID']
  /** The Url of the retailer product's primary image */
  primaryImageUrl: Maybe<Scalars['Url']>
  /** The unique identifier for the associated product */
  productId: Maybe<Scalars['ID']>
  /** The size of the retailer product (e.g., 4 oz) */
  size: Maybe<Scalars['String']>
  /** The unit count of the retailer product */
  unitCount: Maybe<Scalars['Int']>
}

/** The connection type for CatalogRetailerProduct. */
export type CatalogRetailerProductConnection = {
  __typename?: 'CatalogRetailerProductConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogRetailerProductEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogRetailerProduct>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogRetailerProductEdge = {
  __typename?: 'CatalogRetailerProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogRetailerProduct>
}

export type CatalogSearchDownloadsCatalogSearchDownloadSignedUrl = {
  __typename?: 'CatalogSearchDownloadsCatalogSearchDownloadSignedUrl'
  /** Signed url for the object */
  signedUrl: Scalars['String']
}

export type CatalogTaxonomyNode = {
  __typename?: 'CatalogTaxonomyNode'
  /** A unique identifier for the taxonomy node */
  id: Scalars['ID']
  /** The taxonomy nodes's name - ('Food', 'Meat', ...) */
  name: Scalars['String']
  /** The parent taxonomy node */
  parentId: Scalars['ID']
}

export type CatalogWorkflow = {
  __typename?: 'CatalogWorkflow'
  /** The number of associated new-changeset-product-requests with */
  changesetNewProductRequestsCount: Scalars['Int']
  /** The associated changeset products */
  changesetProducts: CatalogChangesetProductConnection
  /** The number of associated changeset products */
  changesetProductsCount: Scalars['Int']
  /** The number of associated changeset products with completed info */
  completedInfoChangesetProductsCount: Scalars['Int']
  /** When the workflow was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog workflow */
  id: Scalars['ID']
  /** The number of associated code lookups */
  importProcessCodeLookupsCount: Scalars['Int']
  /** The associated import processes */
  importProcesses: CatalogImportProcessConnection
  /** The most recent update time for any associated changeset/products/requests */
  latestRelatedUpdateTime: Scalars['Time']
  /** The number of associated changeset products with missing info */
  missingInfoChangesetProductsCount: Scalars['Int']
  /** The number of associated pending code lookups */
  pendingImportProcessCodeLookupsCount: Scalars['Int']
  /** The number of associated pending match code lookups */
  perfectMatchImportProcessCodeLookupsCount: Scalars['Int']
  /** The retailer that this workflow belongs to */
  retailer: Retailer
  /** The number of associated unmatched code lookups */
  unmatchedImportProcessCodeLookupsCount: Scalars['Int']
  /** When the workflow was last updated */
  updatedAt: Scalars['Time']
  /** The owner of the workflow */
  workflowOwner: EnterpriseAccount
  /** The state of the workflow */
  workflowState: WorkflowStateEnum
  /** The type of the workflow */
  workflowType: WorkflowTypeEnum
}

export type CatalogWorkflowChangesetProductsArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type CatalogWorkflowImportProcessesArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for CatalogWorkflow. */
export type CatalogWorkflowConnection = {
  __typename?: 'CatalogWorkflowConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogWorkflowEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogWorkflow>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CatalogWorkflowCreate */
export type CatalogWorkflowCreatePayload = {
  __typename?: 'CatalogWorkflowCreatePayload'
  /** The newly created workflow */
  catalogWorkflow: CatalogWorkflow
}

/** Autogenerated return type of CatalogWorkflowDelete */
export type CatalogWorkflowDeletePayload = {
  __typename?: 'CatalogWorkflowDeletePayload'
  /** Whether the deletion succeeded or not */
  success: Scalars['True']
}

/** An edge in a connection. */
export type CatalogWorkflowEdge = {
  __typename?: 'CatalogWorkflowEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogWorkflow>
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequests */
export type CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveChangesetProducts */
export type CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookups */
export type CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkUpdateChangesetProducts */
export type CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreate */
export type CatalogWorkflowEventCreatePayload = {
  __typename?: 'CatalogWorkflowEventCreatePayload'
  /** A status which is true if no errors were encountered when creating/processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowSubmit */
export type CatalogWorkflowSubmitPayload = {
  __typename?: 'CatalogWorkflowSubmitPayload'
  /** Whether the submission succeeded or not */
  success: Scalars['Boolean']
}

export enum CategorySurfaceType {
  AlcoholSurface = 'ALCOHOL_SURFACE',
  RetailerRecommendation = 'RETAILER_RECOMMENDATION',
}

export enum ChangesetProductStatusEnum {
  /** This changeset product has all the necessary information for submission */
  CompletedInfo = 'COMPLETED_INFO',
  /** This changeset product is missing some details that are required for submission */
  MissingInfo = 'MISSING_INFO',
}

export type ClassificationInfoInput = {
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String']
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum
  /** The id for the associated retailer (for in-house products) */
  retailerId?: Maybe<Scalars['ID']>
}

export enum ClassifiedTypeEnum {
  /** A universal product (standard product with a UPC) */
  Universal = 'UNIVERSAL',
  /** A commodity (bananas, apples, ...) */
  Commodity = 'COMMODITY',
  /** A product that is specific to a retailer (not universal) */
  InHouse = 'IN_HOUSE',
  /** The classification type is not known */
  Unknown = 'UNKNOWN',
}

/** Attributes for creating a code lookup */
export type CodeLookupDataInput = {
  /** The lookup code of the product */
  code: Scalars['String']
  /** The lookup type (e.g., upc, rrc) for search */
  codeLookupType?: Maybe<CodeLookupTypeEnum>
  /** The retailer ID for code lookup */
  retailerId?: Maybe<Scalars['ID']>
  /** The locale code for the code lookup */
  localeCode?: Maybe<Scalars['String']>
}

export enum CodeLookupStateEnum {
  /** A brand new CodeLookup which hasn't been processed yet (no product_ids have been fetched) */
  Pending = 'PENDING',
  /** The CodeLookup is being processed (we are fetching the associated product_ids) */
  InProgress = 'IN_PROGRESS',
  /** The CodeLookup was processed successfully, returning zero or more product_ids */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to fetch the associated product_ids for the CodeLookup */
  Failed = 'FAILED',
}

export enum CodeLookupStatusEnum {
  /** We haven't tried to match this code lookup yet, so we don't know the match status */
  Pending = 'PENDING',
  /** There was exactly one product matching the provided lookup code */
  PerfectMatch = 'PERFECT_MATCH',
  /** There was not exactly one product matching the provided lookup code (either 0 or 2+ items were found) */
  Unmatched = 'UNMATCHED',
}

export enum CodeLookupTypeEnum {
  /** A UPC code */
  Upc = 'UPC',
  /** A RRC code */
  Rrc = 'RRC',
}

export enum CollectionContentTypeEnum {
  /** Collection contains other child collections */
  Collections = 'COLLECTIONS',
  /** Collection contains subjects */
  Rules = 'RULES',
}

/** Autogenerated return type of CollectionCreate */
export type CollectionCreatePayload = {
  __typename?: 'CollectionCreatePayload'
  /** The newly created collection */
  collection: CollectionsCollection
}

/** Autogenerated return type of CollectionDelete */
export type CollectionDeletePayload = {
  __typename?: 'CollectionDeletePayload'
  /** Boolean response that the collection was deleted */
  response: Scalars['Boolean']
}

export type CollectionHeaderInput = {
  /** Title of the collection header */
  title?: Maybe<Scalars['String']>
  /** Description of the collection header */
  description?: Maybe<Scalars['String']>
  /** Display style */
  displayStyle?: Maybe<Scalars['String']>
  /** Hex color for header text */
  color?: Maybe<Scalars['String']>
  /** Hex color for header background */
  backgroundColor?: Maybe<Scalars['String']>
  /** Header image web */
  imageWeb?: Maybe<Scalars['String']>
  /** Header image mobile */
  imageMobile?: Maybe<Scalars['String']>
}

export type CollectionsCollection = {
  __typename?: 'CollectionsCollection'
  /** Whether or not the collection is active */
  active: Scalars['Boolean']
  /** Whether or not the collection is active only for internal admins */
  activeAdminOnly: Scalars['Boolean']
  /** Whether the collection can be edited by the current user */
  canEdit: Scalars['Boolean']
  /** Children collections of the collection */
  children: Maybe<Array<CollectionsCollection>>
  /** Type of collection */
  collectionType: Maybe<CollectionTypeEnum>
  /** End date of collection */
  endDate: Maybe<Scalars['Time']>
  /** Header for the collection */
  header: Maybe<CollectionsHeader>
  /** A unique identifier for the collection */
  id: Scalars['ID']
  /** Path of the collection image */
  imagePath: Maybe<Scalars['String']>
  /** URL of the collection image */
  imageUrl: Maybe<Scalars['String']>
  /** The name of the collection */
  name: Maybe<Scalars['String']>
  /** A unique identifier for the parent collection */
  parentId: Maybe<Scalars['ID']>
  /** Whitelisted retailers for this collection */
  requiredRetailerIds: Maybe<Array<Scalars['ID']>>
  /** The slug of the collection */
  slug: Maybe<Scalars['String']>
  /** Start date of collection */
  startDate: Maybe<Scalars['Time']>
  /** Storefront banner for the collection */
  storefrontBanner: Maybe<CollectionsStorefrontBanner>
  /** Rules for the collection */
  subjects: Maybe<Array<CollectionsSubject>>
}

/** The connection type for CollectionsCollection. */
export type CollectionsCollectionConnection = {
  __typename?: 'CollectionsCollectionConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CollectionsCollectionEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CollectionsCollection>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CollectionsCollectionEdge = {
  __typename?: 'CollectionsCollectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CollectionsCollection>
}

export type CollectionsHeader = {
  __typename?: 'CollectionsHeader'
  /** Color hex value of the header background */
  backgroundColor: Maybe<Scalars['String']>
  /** Collection id associated to the header */
  collectionId: Scalars['ID']
  /** Color hex value of the header */
  color: Maybe<Scalars['String']>
  /** Description of the header */
  description: Maybe<Scalars['String']>
  /** Display style of the header */
  displayStyle: Maybe<Scalars['String']>
  /** A unique identifier for the header */
  id: Scalars['ID']
  /** Image url of the header */
  imageUrl: Maybe<Scalars['String']>
  /** Mobile image url of the header */
  mobileImageUrl: Maybe<Scalars['String']>
  /** Title of the header */
  title: Scalars['String']
}

export type CollectionsStorefrontBanner = {
  __typename?: 'CollectionsStorefrontBanner'
  /** Whether the banner is active */
  active: Maybe<Scalars['Boolean']>
  /** Background color of the storefront banner */
  backgroundColor: Maybe<Scalars['String']>
  /** Collection id associated to the header */
  collectionId: Scalars['ID']
  /** CTA of the storefront banner */
  cta: Maybe<Scalars['String']>
  /** Heading content of the storefront banner */
  heading: Maybe<Scalars['String']>
  /** Hex value heading color of the storefront banner */
  headingColor: Maybe<Scalars['String']>
  /** A unique identifier for the header */
  id: Scalars['ID']
  /** Image url of the storefront banner */
  image: Maybe<Scalars['String']>
  /** Sub heading content of the storefront banner */
  subHeading: Maybe<Scalars['String']>
  /** Sub heading color of the storefront banner */
  subHeadingColor: Maybe<Scalars['String']>
  /** Tag of the storefront banner */
  tag: Maybe<Scalars['String']>
  /** Tag color of the storefront banner */
  tagColor: Maybe<Scalars['String']>
}

export type CollectionsSubject = {
  __typename?: 'CollectionsSubject'
  /** The id of the collection the subject belongs to */
  collectionId: Scalars['ID']
  /** Filter for on sale items if true */
  criteriaOnSale: Maybe<Scalars['Boolean']>
  /** List of product ids for the subject */
  criteriaProductIds: Maybe<Array<Scalars['ID']>>
  /** List of search terms for the subject */
  criteriaTerms: Maybe<Array<Scalars['String']>>
  /** A unique identifier for the subject */
  id: Maybe<Scalars['ID']>
  /** L1 Product Category IDs */
  l1CategoryId: Maybe<Array<Scalars['ID']>>
  /** L2 Product Category IDs */
  l2CategoryId: Maybe<Array<Scalars['ID']>>
  /** L3 Product Category IDs */
  l3CategoryId: Maybe<Array<Scalars['ID']>>
  /** L4 Product Category IDs */
  l4CategoryId: Maybe<Array<Scalars['ID']>>
  /** L5 Product Category IDs */
  l5CategoryId: Maybe<Array<Scalars['ID']>>
  /** L6 Product Category IDs */
  l6CategoryId: Maybe<Array<Scalars['ID']>>
  /** Name of the subject */
  subjectName: Scalars['String']
}

export type CollectionStorefrontBannerInput = {
  /** Background color of the storefront banner */
  backgroundColor?: Maybe<Scalars['String']>
  /** CTA of the storefront banner */
  cta: Scalars['String']
  /** Heading of the storefront banner */
  heading: Scalars['String']
  /** Hex value for the heading color of the storefront banner */
  headingColor: Scalars['String']
  /** Image reference path of the storefront banner */
  image: Scalars['String']
  /** Sub heading of the storefront banner */
  subHeading: Scalars['String']
  /** Sub heading hex color value of the storefront banner */
  subHeadingColor: Scalars['String']
  /** Tag for the storefront banner */
  tag?: Maybe<Scalars['String']>
  /** Hex color value for the tag of the storefront banner */
  tagColor?: Maybe<Scalars['String']>
  /** Whether the storefront banner is active or not */
  active: Scalars['Boolean']
}

export type CollectionSubjectInput = {
  /** Id of the subject when updating */
  subjectId?: Maybe<Scalars['ID']>
  /** Name of the subject */
  subjectName: Scalars['String']
  /** Product ids to add to the collection */
  criteriaProductIds?: Maybe<Array<Scalars['ID']>>
  /** Search term criteria to add to the collection */
  criteriaTerms?: Maybe<Array<Scalars['String']>>
  /** Filter for on sale items */
  criteriaOnSale?: Maybe<Scalars['Boolean']>
}

export enum CollectionTypeEnum {
  /** DESCRIPTION TODO */
  Holiday = 'HOLIDAY',
  /** DESCRIPTION TODO */
  Department = 'DEPARTMENT',
  /** DESCRIPTION TODO */
  Explore = 'EXPLORE',
  /** DESCRIPTION TODO */
  CardList = 'CARD_LIST',
  /** DESCRIPTION TODO */
  Dynamic = 'DYNAMIC',
}

/** Autogenerated return type of CollectionUpdate */
export type CollectionUpdatePayload = {
  __typename?: 'CollectionUpdatePayload'
  /** The updated collection */
  collection: CollectionsCollection
}

export type ConfigurableButtonInput = {
  /** The button style to use */
  styleVariant?: Maybe<ButtonVariantEnum>
  /** The button text */
  label: Scalars['String']
  /** Color of the button text */
  color?: Maybe<Scalars['String']>
  /** Background color of the button */
  backgroundColor?: Maybe<Scalars['String']>
}

export type ConfigurableTextInput = {
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String']
  /** The text to display */
  text: Scalars['String']
}

export type ConnectionMeta = {
  __typename?: 'ConnectionMeta'
  /** The total number of connection elements */
  totalCount: Scalars['Int']
}

export type ContentManagementAnnouncementBannerGenericImages = {
  __typename?: 'ContentManagementAnnouncementBannerGenericImages'
  /** The foreground image url in the placement to be used on desktop clients */
  desktop: Maybe<Scalars['Url']>
  /** The foreground image url in the placement to be used on mobile clients */
  mobile: Scalars['Url']
}

export type ContentManagementAnnouncementBannerImageForwardImages = {
  __typename?: 'ContentManagementAnnouncementBannerImageForwardImages'
  /** The foreground image url in the placement to be used on desktop clients */
  desktop: Scalars['Url']
  /** The foreground image url in the placement to be used on mobile clients */
  mobile: Scalars['Url']
}

export type ContentManagementAnnouncementBannerTextWithThumbnailImages = {
  __typename?: 'ContentManagementAnnouncementBannerTextWithThumbnailImages'
  /** The background image url of the placement */
  background: Scalars['Url']
  /** The image url of the placement to display for the logo image */
  logo: Scalars['Url']
}

export type ContentManagementConfigurableButton = {
  __typename?: 'ContentManagementConfigurableButton'
  /** The background color of the button (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** Color of the button text (Eg. #000000) */
  color: Maybe<Scalars['String']>
  /** The button text */
  label: Scalars['String']
  /** The button style to use */
  styleVariant: ButtonVariantEnum
}

export type ContentManagementConfigurableText = {
  __typename?: 'ContentManagementConfigurableText'
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String']
  /** The text to display */
  text: Maybe<Scalars['String']>
}

export type ContentManagementHeroBannerPlacement = {
  __typename?: 'ContentManagementHeroBannerPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The color of the text area (Eg. #FFFFFF) */
  textareaColor: Maybe<Scalars['String']>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementImageForwardFlexPlacement = {
  __typename?: 'ContentManagementImageForwardFlexPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerImageForwardImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementImageForwardPlacement = {
  __typename?: 'ContentManagementImageForwardPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerImageForwardImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementPbiConfiguration = {
  __typename?: 'ContentManagementPbiConfiguration'
  /** The url for the retailer's pbi instance */
  domainName: Scalars['String']
  /** The unique slug for the retailer */
  slug: Scalars['String']
}

export type ContentManagementPlacementDestination = {
  __typename?: 'ContentManagementPlacementDestination'
  /** The human readable value of the target */
  displayValue: Maybe<Scalars['String']>
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String']
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum
}

export type ContentManagementPlacementExperiment = {
  __typename?: 'ContentManagementPlacementExperiment'
  /** Experiment Assignment or Lookup */
  accessMethod: Maybe<PlacementExperimentMethodEnum>
  /** Name of the Experiment */
  name: Maybe<Scalars['String']>
  /** Variant of the Experiment for which placement should be visible */
  variant: Maybe<Scalars['String']>
}

export type ContentManagementPlacementImages = {
  __typename?: 'ContentManagementPlacementImages'
  /** The image url of the placement to display for large viewports */
  large: Scalars['Url']
  /** The image url of the placement to display for small viewports */
  small: Scalars['Url']
}

export type ContentManagementPlacementSchedule = {
  __typename?: 'ContentManagementPlacementSchedule'
  /** When the placement should stop being active */
  endDate: Maybe<Scalars['Time']>
  /** When the placement should become active */
  startDate: Scalars['Time']
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Maybe<Scalars['String']>
}

export type ContentManagementSecondaryBannerPlacement = {
  __typename?: 'ContentManagementSecondaryBannerPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The style and text of the secondary text */
  secondaryText: Maybe<ContentManagementConfigurableText>
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementStorefrontPlacement = {
  __typename?: 'ContentManagementStorefrontPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The banners configured to the placement */
  banners: Array<ContentManagementStorefrontPlacementBanner>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** Whether or not the placement can be dismissed */
  dismissable: Scalars['Boolean']
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: ContentManagementPlacementImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** A unique identifier for the retailer */
  retailerId: Scalars['ID']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementStorefrontPlacementBanner = {
  __typename?: 'ContentManagementStorefrontPlacementBanner'
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier of the banner associated with the placement */
  id: Maybe<Scalars['ID']>
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: ContentManagementPlacementImages
  /** The banner's locale */
  locale: Maybe<BannerLocaleEnum>
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
}

/** The connection type for ContentManagementStorefrontPlacement. */
export type ContentManagementStorefrontPlacementConnection = {
  __typename?: 'ContentManagementStorefrontPlacementConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ContentManagementStorefrontPlacementEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ContentManagementStorefrontPlacement>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentManagementStorefrontPlacementEdge = {
  __typename?: 'ContentManagementStorefrontPlacementEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<ContentManagementStorefrontPlacement>
}

export type ContentManagementTextWithThumbnailFlexPlacement = {
  __typename?: 'ContentManagementTextWithThumbnailFlexPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerTextWithThumbnailImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementTextWithThumbnailPlacement = {
  __typename?: 'ContentManagementTextWithThumbnailPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerTextWithThumbnailImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementUnknownBannerPlacement = {
  __typename?: 'ContentManagementUnknownBannerPlacement'
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementVisibilityConditionExpressMembership = {
  __typename?: 'ContentManagementVisibilityConditionExpressMembership'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>
}

export type ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout = {
  __typename?: 'ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>
}

export type ContentManagementVisibilityConditionMinimumPlatformVersion = {
  __typename?: 'ContentManagementVisibilityConditionMinimumPlatformVersion'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum
  /** Version used for the check */
  version: Scalars['String']
}

export type ContentManagementVisibilityConditionShoppedAtRetailer = {
  __typename?: 'ContentManagementVisibilityConditionShoppedAtRetailer'
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the Retailer */
  retailerId: Scalars['Int']
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int']
}

export type ContentManagementVisibilityConditionWhitelistedPostalCodes = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedPostalCodes'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>
}

export enum CostUnitEnum {
  /** The `each` cost unit */
  Each = 'EACH',
  /** The `lb` cost unit */
  Pound = 'POUND',
  /** The `kg` cost unit */
  Kilogram = 'KILOGRAM',
}

export type CreatePlacementRequestInput = {
  placement?: Maybe<PlacementInput>
}

export type CreatePlacementResponse = {
  __typename?: 'CreatePlacementResponse'
  placement: Maybe<Placement>
}

export type CustomersContext = {
  __typename?: 'CustomersContext'
  storeConfigurationId: Maybe<Scalars['Int']>
  clientConfigurationId: Maybe<Scalars['Int']>
  countryId: Maybe<Scalars['Int']>
}

/** Attributes for a date range filter */
export type DateRange = {
  /** Start date of date range */
  startDate: Scalars['ISO8601Date']
  /** End date of date range */
  endDate: Scalars['ISO8601Date']
}

export type DateRangeInput = {
  from?: Maybe<Scalars['DateTime']>
  to?: Maybe<Scalars['DateTime']>
}

export type DateTimeRangeInput = {
  from?: Maybe<Scalars['DateTime']>
  to?: Maybe<Scalars['DateTime']>
}

export type DeleteApiSettingRequestInput = {
  id?: Maybe<Scalars['BigInt']>
  partnerId?: Maybe<Scalars['BigInt']>
}

export type DeleteApiSettingResponse = {
  __typename?: 'DeleteApiSettingResponse'
  success: Maybe<Scalars['Boolean']>
}

export type Department = {
  __typename?: 'Department'
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
}

export enum DeviceTypeEnum {
  /** Phone plan */
  Phone = 'phone',
  /** Wi-Fi */
  Wifi = 'wifi',
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type DoNotNavigate = {
  __typename?: 'DoNotNavigate'
  recordClickAttempt: Maybe<Scalars['Boolean']>
}

export type DoNotNavigateInput = {
  recordClickAttempt?: Maybe<Scalars['Boolean']>
}

export type DownloadCatalogSearchResultsRequestInput = {
  requestProductData?: Maybe<Scalars['Boolean']>
  requestItemData?: Maybe<Scalars['Boolean']>
  productFilename?: Maybe<Scalars['String']>
  itemFilename?: Maybe<Scalars['String']>
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  primaryImageUrl?: Maybe<Scalars['Boolean']>
  storeBrandProduct?: Maybe<Scalars['Boolean']>
  creationDate?: Maybe<DateRangeInput>
  productAvailability?: Maybe<Scalars['Boolean']>
  itemsOnSaleDateRange?: Maybe<DateRangeInput>
  itemsOnPromoDateRange?: Maybe<DateRangeInput>
  loyaltyPricing?: Maybe<Scalars['Boolean']>
  snapEbtEligible?: Maybe<Scalars['Boolean']>
  costUnitType?: Maybe<Array<Maybe<Scalars['String']>>>
  isParWeighted?: Maybe<Scalars['Boolean']>
  retailerReferenceCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  query?: Maybe<Scalars['String']>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
  retailerId?: Maybe<Scalars['BigInt']>
}

export type DownloadCatalogSearchResultsResponse = {
  __typename?: 'DownloadCatalogSearchResultsResponse'
  _: Maybe<Scalars['Boolean']>
}

export type EnterpriseAccount = {
  __typename?: 'EnterpriseAccount'
  /** Whether or not the user is fully set up */
  accountStateValid: Maybe<Scalars['Boolean']>
  /** The associated authentication */
  authentication: Maybe<AuthenticationInterface>
  /** The external unique identifier for the enterprise account */
  canonicalId: Scalars['ID']
  /** When the account was created */
  createdAt: Scalars['Time']
  /** Whether account is active */
  disabled: Scalars['Boolean']
  /** The email associated with the account */
  email: Maybe<Scalars['String']>
  /** The flippers associated with the account */
  flippers: AccessControlFlippers
  /** Given name of user */
  givenName: Maybe<Scalars['String']>
  /** The internal unique identifier for the enterprise account */
  id: Scalars['ID']
  /** The associated internal access configuration for the account */
  internalAccessConfiguration: EnterpriseInternalAccessConfiguration
  /** The permissions associated with this account */
  permissions: Array<EnterprisePermission>
  /** Phone number for the user */
  phone: Maybe<Scalars['String']>
  /** The policies associated with the account */
  policies: AccessControlPolicies
  /** The roles associated with this account */
  roles: Array<EnterpriseRole>
  /** Surname of user */
  surname: Maybe<Scalars['String']>
  /** The title of the user */
  title: Maybe<Scalars['String']>
}

/** Autogenerated return type of EnterpriseAccountAccountSetup */
export type EnterpriseAccountAccountSetupPayload = {
  __typename?: 'EnterpriseAccountAccountSetupPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountAuthenticateEmailPassword */
export type EnterpriseAccountAuthenticateEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountAuthenticateEmailPasswordPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountAuthenticatePreflight */
export type EnterpriseAccountAuthenticatePreflightPayload = {
  __typename?: 'EnterpriseAccountAuthenticatePreflightPayload'
  useAuthService: Scalars['Boolean']
}

/** The connection type for EnterpriseAccount. */
export type EnterpriseAccountConnection = {
  __typename?: 'EnterpriseAccountConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EnterpriseAccountEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EnterpriseAccount>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of EnterpriseAccountCreate */
export type EnterpriseAccountCreatePayload = {
  __typename?: 'EnterpriseAccountCreatePayload'
  /** The newly created account object */
  enterpriseAccount: EnterpriseAccount
}

/** An edge in a connection. */
export type EnterpriseAccountEdge = {
  __typename?: 'EnterpriseAccountEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<EnterpriseAccount>
}

/** Autogenerated return type of EnterpriseAccountRequestAccountSetupEmail */
export type EnterpriseAccountRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountRequestAccountSetupEmailPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountRequestEmailVerification */
export type EnterpriseAccountRequestEmailVerificationPayload = {
  __typename?: 'EnterpriseAccountRequestEmailVerificationPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountRequestPasswordReset */
export type EnterpriseAccountRequestPasswordResetPayload = {
  __typename?: 'EnterpriseAccountRequestPasswordResetPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountResetPassword */
export type EnterpriseAccountResetPasswordPayload = {
  __typename?: 'EnterpriseAccountResetPasswordPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountSetDisabled */
export type EnterpriseAccountSetDisabledPayload = {
  __typename?: 'EnterpriseAccountSetDisabledPayload'
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountSignUpEmailPassword */
export type EnterpriseAccountSignUpEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountSignUpEmailPasswordPayload'
  /** The newly created Account */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountUpdate */
export type EnterpriseAccountUpdatePayload = {
  __typename?: 'EnterpriseAccountUpdatePayload'
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountVerifyEmail */
export type EnterpriseAccountVerifyEmailPayload = {
  __typename?: 'EnterpriseAccountVerifyEmailPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

export type EnterpriseAuthenticationEmailPassword = AuthenticationInterface & {
  __typename?: 'EnterpriseAuthenticationEmailPassword'
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID']
  /** Whether or not the email has been verified */
  emailVerified: Scalars['Boolean']
  /** Whether or not the password has been set */
  passwordSet: Scalars['Boolean']
}

export type EnterpriseInternalAccessConfiguration = {
  __typename?: 'EnterpriseInternalAccessConfiguration'
  /** The associated assigned partners */
  assignedPartners: Array<Partner>
  /** The associated assigned retailer locations */
  assignedRetailerLocations: Array<RetailerLocation>
  /** The associated assigned retailers */
  assignedRetailers: Array<Retailer>
  /** Whether access is granted for every partner, retailer and location */
  hasAllPartnersFullAccess: Scalars['Boolean']
  /** Whether access is granted for every retailer and location for partners assigned */
  hasFullPartnerAccess: Scalars['Boolean']
  /** Whether access is granted for every location for retailers assigned */
  hasFullRetailerAccess: Scalars['Boolean']
  /** Whether access is not granted to any partner, retailer or location */
  hasNothingAccessible: Scalars['Boolean']
}

export type EnterprisePermission = {
  __typename?: 'EnterprisePermission'
  /** A description of the permission */
  description: Maybe<Scalars['String']>
  /** A unique identifier for the permission */
  slug: Scalars['ID']
}

export type EnterpriseRole = {
  __typename?: 'EnterpriseRole'
  /** A description of the role */
  description: Maybe<Scalars['String']>
  /** The role ID */
  id: Scalars['ID']
  /** Whether this role is managed internally or not */
  internallyManaged: Scalars['Boolean']
  /** The name of the role */
  name: Scalars['String']
  /** The permissions associated with this role */
  permissions: Array<EnterprisePermission>
  /** A unique identifier for the role */
  slug: Scalars['ID']
}

export enum ExperimentMethod {
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  Assign = 'ASSIGN',
  Lookup = 'LOOKUP',
}

export type ExpressMembershipInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean']
}

/** Autogenerated return type of ExpressMembershipVisibilityConditionCreate */
export type ExpressMembershipVisibilityConditionCreatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionCreatePayload'
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership
}

/** Autogenerated return type of ExpressMembershipVisibilityConditionUpdate */
export type ExpressMembershipVisibilityConditionUpdatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionUpdatePayload'
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership
}

export type ExpressNonmemberLongTermHoldoutInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of ExpressNonmemberLongTermHoldoutVisibilityConditionCreate */
export type ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload = {
  __typename?: 'ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload'
  /** The newly created ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityCondition: ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout
}

export enum FulfillmentModelEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Locker */
  Locker = 'LOCKER',
  /** In store shoppers */
  Iss = 'ISS',
}

export type GenericImagesInput = {
  /** The image url of the placement to display for small viewports */
  mobile: Scalars['Url']
  /** The image url of the placement to display for large viewports */
  desktop?: Maybe<Scalars['Url']>
}

export type GetApiSettingsRequestInput = {
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  apiType?: Maybe<Scalars['String']>
  integrationType?: Maybe<Scalars['String']>
  enabled?: Maybe<Scalars['Boolean']>
}

export type GetApiSettingsResponse = {
  __typename?: 'GetApiSettingsResponse'
  apiSettings: Maybe<Array<Maybe<ApiSetting>>>
}

export type GetAuthenticationUrlRequestInput = {
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  integrationType?: Maybe<Scalars['String']>
  successRedirectUrl?: Maybe<Scalars['String']>
  errorRedirectUrl?: Maybe<Scalars['String']>
}

export type GetAuthenticationUrlResponse = {
  __typename?: 'GetAuthenticationUrlResponse'
  authenticationUrl: Maybe<Scalars['String']>
}

export type GetCustomersContextRequestInput = {
  parameters?: Maybe<GetCustomersContextRequestParametersInput>
  timeoutMs?: Maybe<Scalars['BigInt']>
}

export type GetCustomersContextRequestParametersInput = {
  partnerId?: Maybe<Scalars['Int']>
}

export type GetCustomersContextResponse = {
  __typename?: 'GetCustomersContextResponse'
  context: Maybe<CustomersContext>
}

export type GetDashboardOrderRequestInput = {
  userId?: Maybe<Scalars['BigInt']>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
}

export type GetDashboardOrderResponse = {
  __typename?: 'GetDashboardOrderResponse'
  dashboardOrder: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrder>
}

export type GetItemsRequestInput = {
  parameters?: Maybe<GetItemsRequestParametersInput>
  timeoutMs?: Maybe<Scalars['BigInt']>
}

export type GetItemsRequestParametersInput = {
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  limit?: Maybe<Scalars['BigInt']>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
  offset?: Maybe<Scalars['BigInt']>
  inventoryAreaId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  primaryAisleId?: Maybe<Scalars['BigInt']>
  primaryDepartmentId?: Maybe<Scalars['BigInt']>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type GetItemsResponse = {
  __typename?: 'GetItemsResponse'
  results: Maybe<Array<Maybe<Item>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type GetLegacyElasticsearchRequestInput = {
  inventoryAreaId?: Maybe<Scalars['BigInt']>
  itemIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  select?: Maybe<Array<Maybe<Scalars['String']>>>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
}

export type GetLegacyProductsRequestInput = {
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  limit?: Maybe<Scalars['BigInt']>
  offset?: Maybe<Scalars['BigInt']>
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  select?: Maybe<Array<Maybe<Scalars['String']>>>
  source?: Maybe<Scalars['String']>
  query?: Maybe<Scalars['String']>
  inventoryAreaIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  availableInventoryAreaIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  regionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type GetLocalesByRetailerRequestInput = {
  retailerId?: Maybe<Scalars['BigInt']>
}

export type GetLocalesByRetailerResponse = {
  __typename?: 'GetLocalesByRetailerResponse'
  retailerLocales: Maybe<Array<Maybe<RetailerLocale>>>
}

export type GetOrderLocationRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
}

export type GetOrderLocationResponse = {
  __typename?: 'GetOrderLocationResponse'
  shopperCoordinates: Maybe<GoogleTypeLatLng>
}

export type GetOrderRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  userId?: Maybe<Scalars['BigInt']>
  orderId?: Maybe<Scalars['BigInt']>
  externalId?: Maybe<Scalars['String']>
}

export type GetOrderResponse = {
  __typename?: 'GetOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>
}

export type GetPlacementsRequestInput = {
  placementId?: Maybe<Scalars['BigInt']>
  userId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  platform?: Maybe<Array<Maybe<PlatformType>>>
  variant?: Maybe<Array<Maybe<BannerVariant>>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<Direction>
  limit?: Maybe<Scalars['BigInt']>
  searchTerm?: Maybe<Scalars['String']>
  status?: Maybe<Array<Maybe<Status>>>
  type?: Maybe<Scalars['String']>
  enabledOnly?: Maybe<Scalars['Boolean']>
}

export type GetRetailerProductDataRequestInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type GetRetailerProductDataResponse = {
  __typename?: 'GetRetailerProductDataResponse'
  retailerProductData: Maybe<Array<Maybe<RetailerProductData>>>
}

export type GetRetailerProductsRequestInput = {
  parameters?: Maybe<GetRetailerProductsRequestParametersInput>
  timeoutMs?: Maybe<Scalars['BigInt']>
}

export type GetRetailerProductsRequestParametersInput = {
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  limit?: Maybe<Scalars['BigInt']>
  localeCode?: Maybe<InstacartCustomersSharedV1Locale>
  offset?: Maybe<Scalars['BigInt']>
  orderBy?: Maybe<InstacartCustomersSharedV1OrderInput>
  primaryAisleId?: Maybe<Scalars['BigInt']>
  primaryDepartmentId?: Maybe<Scalars['BigInt']>
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  query?: Maybe<Scalars['String']>
  retailerId?: Maybe<Scalars['BigInt']>
  retailerProductIds?: Maybe<Array<Maybe<RetailerProductIdInput>>>
  retailerReferenceCodes?: Maybe<Array<Maybe<Scalars['String']>>>
  select?: Maybe<Array<Maybe<Scalars['String']>>>
  hasPrimaryImageUrl?: Maybe<Scalars['Boolean']>
  isStoreBrandProduct?: Maybe<Scalars['Boolean']>
  productCreationDateRange?: Maybe<DateTimeRangeInput>
}

export type GetRetailerProductsResponse = {
  __typename?: 'GetRetailerProductsResponse'
  results: Maybe<Array<Maybe<RetailerProduct>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type GoogleTypeDateInput = {
  year?: Maybe<Scalars['Int']>
  month?: Maybe<Scalars['Int']>
  day?: Maybe<Scalars['Int']>
}

export type GoogleTypeLatLng = {
  __typename?: 'GoogleTypeLatLng'
  latitude: Maybe<Scalars['Float']>
  longitude: Maybe<Scalars['Float']>
}

export type HealthCheck = {
  __typename?: 'HealthCheck'
  /** Server health status */
  alive: Scalars['True']
  /** Postgresql health status */
  postgresql: Maybe<Scalars['Boolean']>
  /** Redis health status */
  redis: Maybe<Scalars['Boolean']>
  /** Snowflake health status */
  snowflake: Maybe<Scalars['Boolean']>
}

export type HeroBanner = {
  __typename?: 'HeroBanner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  textAreaColorHex: Maybe<Scalars['String']>
}

export type HeroBannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
  textAreaColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of HeroBannerPlacementCreate */
export type HeroBannerPlacementCreatePayload = {
  __typename?: 'HeroBannerPlacementCreatePayload'
  /** The newly created hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement
}

export type HeroBannerPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: GenericImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The color of the text area for placements (Eg. #FFFFFF) */
  textareaColor?: Maybe<Scalars['String']>
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of HeroBannerPlacementUpdate */
export type HeroBannerPlacementUpdatePayload = {
  __typename?: 'HeroBannerPlacementUpdatePayload'
  /** The updated hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement
}

export type HistoricalPerformanceOverviewRecord = {
  __typename?: 'HistoricalPerformanceOverviewRecord'
  metricType: Maybe<MetricType>
  currentValue: Maybe<InstacartTypesV1BigDecimal>
  pastValue: Maybe<InstacartTypesV1BigDecimal>
}

export type HistoricalStorePerformanceRecord = {
  __typename?: 'HistoricalStorePerformanceRecord'
  warehouseLocationId: Maybe<Scalars['BigInt']>
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>
  scheduledGaps: Maybe<Scalars['Int']>
  matchRate: Maybe<InstacartTypesV1BigDecimal>
  utilizationRate: Maybe<InstacartTypesV1BigDecimal>
  fiveHourAvailabilityRate: Maybe<InstacartTypesV1BigDecimal>
  partnerPickOrdersCount: Maybe<Scalars['Int']>
  fssOrdersCount: Maybe<Scalars['Int']>
  dedicatedMatchRate: Maybe<InstacartTypesV1BigDecimal>
  dedicatedUtilizationRate: Maybe<InstacartTypesV1BigDecimal>
  name: Maybe<Scalars['String']>
}

export type HistoricalStorePerformanceRequestInput = {
  warehouseId?: Maybe<Scalars['BigInt']>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
  metricThresholds?: Maybe<Array<Maybe<MetricThresholdInput>>>
  warehouseLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  devicePrioritizationEnabled?: Maybe<Scalars['Boolean']>
}

export type HistoricalStorePerformanceResponse = {
  __typename?: 'HistoricalStorePerformanceResponse'
  warehouseId: Maybe<Scalars['BigInt']>
  updatedAt: Maybe<Scalars['DateTime']>
  overviewMetrics: Maybe<Array<Maybe<HistoricalPerformanceOverviewRecord>>>
  metrics: Maybe<Array<Maybe<HistoricalStorePerformanceRecord>>>
}

/** Types of Home Placements which may be returned */
export type HomePlacement =
  | ContentManagementHeroBannerPlacement
  | ContentManagementImageForwardFlexPlacement
  | ContentManagementImageForwardPlacement
  | ContentManagementSecondaryBannerPlacement
  | ContentManagementTextWithThumbnailFlexPlacement
  | ContentManagementTextWithThumbnailPlacement
  | ContentManagementUnknownBannerPlacement

export type HubPaginationMeta = {
  __typename?: 'HubPaginationMeta'
  perPage: Scalars['Int']
  totalCount: Scalars['Int']
  totalPages: Scalars['Int']
}

export type ImageForward = {
  __typename?: 'ImageForward'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
}

export type ImageForwardFlex = {
  __typename?: 'ImageForwardFlex'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
}

export type ImageForwardFlexInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of ImageForwardFlexPlacementCreate */
export type ImageForwardFlexPlacementCreatePayload = {
  __typename?: 'ImageForwardFlexPlacementCreatePayload'
  /** The newly created image_forward_flex placement */
  imageForwardFlexPlacement: ContentManagementImageForwardFlexPlacement
}

export type ImageForwardFlexPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: ImageForwardImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of ImageForwardFlexPlacementUpdate */
export type ImageForwardFlexPlacementUpdatePayload = {
  __typename?: 'ImageForwardFlexPlacementUpdatePayload'
  /** The updated image_forward_flex placement */
  imageForwardFlexPlacement: ContentManagementImageForwardFlexPlacement
}

export type ImageForwardImagesInput = {
  /** The image url of the placement to display for small viewports */
  mobile: Scalars['Url']
  /** The image url of the placement to display for large viewports */
  desktop?: Maybe<Scalars['Url']>
}

export type ImageForwardInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of ImageForwardPlacementCreate */
export type ImageForwardPlacementCreatePayload = {
  __typename?: 'ImageForwardPlacementCreatePayload'
  /** The newly created image_forward placement */
  imageForwardPlacement: ContentManagementImageForwardPlacement
}

export type ImageForwardPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: ImageForwardImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of ImageForwardPlacementUpdate */
export type ImageForwardPlacementUpdatePayload = {
  __typename?: 'ImageForwardPlacementUpdatePayload'
  /** The updated image_forward placement */
  imageForwardPlacement: ContentManagementImageForwardPlacement
}

export type ImageInfo = {
  __typename?: 'ImageInfo'
  imageType: Maybe<Scalars['String']>
  imageId: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  sourceType: Maybe<Scalars['String']>
}

/** Attributes for creating a code lookup */
export type ImportProcessCodeLookupDataInput = {
  /** The lookup code of the product */
  code: Scalars['String']
  /** The price per cost unit of the product */
  pricePerCostUnit?: Maybe<Scalars['Float']>
}

export enum ImportProcessCodeLookupStateEnum {
  /** A brand new ImportProcessCodeLookup which hasn't been processed yet (no product_ids have been fetched) */
  Pending = 'PENDING',
  /** The ImportProcessCodeLookup is being processed (we are fetching the associated product_ids) */
  InProgress = 'IN_PROGRESS',
  /** The ImportProcessCodeLookup was processed successfully, returning zero or more product_ids */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to fetch the associated product_ids for the ImportProcessCodeLookup */
  Failed = 'FAILED',
}

export enum ImportProcessCodeLookupStatusEnum {
  /** We haven't tried to match this code lookup yet, so we don't know the match status */
  Pending = 'PENDING',
  /** There was exactly one product matching the provided lookup code */
  PerfectMatch = 'PERFECT_MATCH',
  /** There was not exactly one product matching the provided lookup code (either 0 or 2+ items were found) */
  Unmatched = 'UNMATCHED',
}

export enum ImportProcessCodeLookupTypeEnum {
  /** A UPC code */
  Upc = 'UPC',
}

export enum ImportProcessStateEnum {
  /** A new import process with no associated ImportProcessCodeLookups */
  Pending = 'PENDING',
  /** The associated ImportProcessCodeLookups have started to be created */
  InProgress = 'IN_PROGRESS',
  /** The associated ImportProcessCodeLookups have all been created */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to create the ImportProcessCodeLookups */
  Failed = 'FAILED',
}

export enum ImportProcessTypeEnum {
  /** A code-lookup type import process */
  CodeLookup = 'CODE_LOOKUP',
}

export enum InstacartCustomersSharedV1Locale {
  LocaleUnspecified = 'LOCALE_UNSPECIFIED',
  EnUs = 'EN_US',
  EnCa = 'EN_CA',
  FrCa = 'FR_CA',
  EnAu = 'EN_AU',
}

export enum InstacartCustomersSharedV1OrderAttributeDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type InstacartCustomersSharedV1OrderAttributeInput = {
  name?: Maybe<Scalars['String']>
  direction?: Maybe<InstacartCustomersSharedV1OrderAttributeDirection>
}

export type InstacartCustomersSharedV1OrderInput = {
  attributes?: Maybe<Array<Maybe<InstacartCustomersSharedV1OrderAttributeInput>>>
}

export type InstacartEnterpriseBobaCoreTypesV1AddressInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1AddressInformation'
  streetName: Maybe<Scalars['String']>
  unitNumber: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1CustomerInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1CustomerInformation'
  customerFirstName: Maybe<Scalars['String']>
  customerLastName: Maybe<Scalars['String']>
  customerFullName: Maybe<Scalars['String']>
  customerPhoneNumber: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrder = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrder'
  id: Maybe<Scalars['BigInt']>
  orderDeliveryId: Maybe<Scalars['BigInt']>
  displayId: Maybe<Scalars['BigInt']>
  userId: Maybe<Scalars['BigInt']>
  warehouseId: Maybe<Scalars['Int']>
  warehouseLocationId: Maybe<Scalars['BigInt']>
  retailerProvidedAmounts: Maybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts>
  alcoholic: Maybe<Scalars['Boolean']>
  initialTip: Maybe<Scalars['Float']>
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>
  dashboardOptions: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions>
  shopperFirstName: Maybe<Scalars['String']>
  customerInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1CustomerInformation>
  addressInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1AddressInformation>
  workflowState: Maybe<Scalars['String']>
  estimatedPickupTime: Maybe<Scalars['DateTime']>
  estimatedDeliveryTime: Maybe<Scalars['DateTime']>
  shopperAvatarUrl: Maybe<Scalars['String']>
  addressLatitude: Maybe<Scalars['Float']>
  addressLongitude: Maybe<Scalars['Float']>
  customerContext: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext>
  formattedTipAmount: Maybe<Scalars['String']>
  warehouseLocationName: Maybe<Scalars['String']>
  externalId: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext'
  storeConfigurationId: Maybe<Scalars['Int']>
  clientConfigurationId: Maybe<Scalars['Int']>
  countryId: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions'
  leaveUnattended: Maybe<Scalars['Boolean']>
  specialInstructions: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails'
  fulfillmentType: Maybe<Scalars['String']>
  serviceOptionId: Maybe<Scalars['BigInt']>
  windowStartsAt: Maybe<Scalars['DateTime']>
  windowEndsAt: Maybe<Scalars['DateTime']>
  warehouseLocationId: Maybe<Scalars['BigInt']>
  addressId: Maybe<Scalars['BigInt']>
  numOfBags: Maybe<Scalars['BigInt']>
}

export type InstacartEnterpriseBobaCoreTypesV1ItemReplacement = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ItemReplacement'
  itemUpc: Maybe<Scalars['String']>
  itemRrc: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1Order = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1Order'
  id: Maybe<Scalars['BigInt']>
  orderDeliveryId: Maybe<Scalars['BigInt']>
  displayId: Maybe<Scalars['BigInt']>
  userId: Maybe<Scalars['BigInt']>
  warehouseId: Maybe<Scalars['BigInt']>
  loyaltyCardId: Maybe<Scalars['BigInt']>
  workflowState: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  updatedAt: Maybe<Scalars['DateTime']>
  canceledAt: Maybe<Scalars['DateTime']>
  completedAt: Maybe<Scalars['DateTime']>
  deliveredAt: Maybe<Scalars['DateTime']>
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalData>
  statusUrl: Maybe<Scalars['String']>
  timezone: Maybe<Scalars['String']>
  cancellationReason: Maybe<Scalars['String']>
  postCheckoutLink: Maybe<Scalars['String']>
  locale: Maybe<Scalars['String']>
  warnings: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderWarning>>>
  deliveryEta: Maybe<Scalars['DateTime']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderExternalData'
  externalId: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput = {
  externalId?: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItem = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItem'
  id: Maybe<Scalars['BigInt']>
  orderId: Maybe<Scalars['BigInt']>
  itemId: Maybe<Scalars['BigInt']>
  substituteId: Maybe<Scalars['BigInt']>
  quantity: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity>
  status: Maybe<Scalars['String']>
  itemProperties: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemProperties>
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData>
  createdAt: Maybe<Scalars['DateTime']>
  updatedAt: Maybe<Scalars['DateTime']>
  pickedAt: Maybe<Scalars['DateTime']>
  replacementPolicy: Maybe<Scalars['String']>
  replacementItem: Maybe<InstacartEnterpriseBobaCoreTypesV1ItemReplacement>
  isAddOnItem: Maybe<Scalars['Boolean']>
  itemCodes: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemCodes>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemCodes = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemCodes'
  requestedUpc: Maybe<Scalars['String']>
  requestedRrc: Maybe<Scalars['String']>
  deliveredUpc: Maybe<Scalars['String']>
  deliveredRrc: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData'
  lineNum: Maybe<Scalars['String']>
  itemUpc: Maybe<Scalars['String']>
  itemRrc: Maybe<Scalars['String']>
  scanCode: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemProperties = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemProperties'
  productId: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  productType: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity'
  unit: Maybe<Scalars['String']>
  weightOrdered: Maybe<Scalars['Float']>
  countOrdered: Maybe<Scalars['Int']>
  weightDelivered: Maybe<Scalars['Float']>
  countDelivered: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderWarning = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderWarning'
  message: Maybe<Scalars['String']>
  errorCode: Maybe<Scalars['Int']>
  itemCodes: Maybe<Array<Maybe<Scalars['String']>>>
}

export type InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput = {
  id?: Maybe<Scalars['BigInt']>
  serviceOptionId?: Maybe<Scalars['BigInt']>
  startAt?: Maybe<Scalars['String']>
  endAt?: Maybe<Scalars['String']>
  externalData?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>
}

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts'
  cartTotal: Maybe<Scalars['Float']>
  itemsCount: Maybe<Scalars['Int']>
  itemsWeight: Maybe<Scalars['Float']>
  bagsCount: Maybe<Scalars['Int']>
}

export type InstacartTypesV1BigDecimal = {
  __typename?: 'InstacartTypesV1BigDecimal'
  units: Maybe<Scalars['BigInt']>
  nanos: Maybe<Scalars['Int']>
}

export type InstacartTypesV1RequestContextInput = {
  storeConfigurationId?: Maybe<Scalars['Int']>
  clientConfigurationId?: Maybe<Scalars['Int']>
  countryId?: Maybe<Scalars['Int']>
  applicationId?: Maybe<Scalars['Int']>
}

export type Item = {
  __typename?: 'Item'
  localeCode: Maybe<Scalars['String']>
  primaryAisleId: Maybe<Scalars['BigInt']>
  primaryImageUrl: Maybe<Scalars['String']>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productDisplayName: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  retailerReferenceCode: Maybe<Scalars['String']>
  primaryDepartmentId: Maybe<Scalars['BigInt']>
}

export enum Layout {
  Storefront = 'STOREFRONT',
  Home = 'HOME',
}

export type LegacyBaseImageType = {
  __typename?: 'LegacyBaseImageType'
  /** The image url */
  url: Maybe<Scalars['String']>
}

export type LegacyConfigurationType = {
  __typename?: 'LegacyConfigurationType'
  knowledgeOwl: LegacyKnowledgeOwlType
}

export type LegacyCountryType = {
  __typename?: 'LegacyCountryType'
  /** Unique identifier */
  id: Scalars['ID']
  /** country name */
  name: Scalars['String']
}

export type LegacyDeliveryHoursType = {
  __typename?: 'LegacyDeliveryHoursType'
  /** Date of Delivery Hours */
  date: Scalars['LegacyDate']
  /** Ending hour of Delivery Hours on specified date */
  endsAtHour: Scalars['Int']
  /** Starting hour of Delivery Hours on specified date */
  startsAtHour: Scalars['Int']
  /** The associated warehouse of the delivery hours */
  warehouse: LegacyWarehouseType
}

export type LegacyElasticsearchResponse = {
  __typename?: 'LegacyElasticsearchResponse'
  docs: Maybe<Array<Maybe<Scalars['JSONObject']>>>
}

export enum LegacyFulfillmentMethodEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Locker */
  Locker = 'LOCKER',
  /** In store shoppers */
  Iss = 'ISS',
}

export type LegacyHealthCheckType = {
  __typename?: 'LegacyHealthCheckType'
  /** Server health status */
  ok: Scalars['Boolean']
}

export type LegacyKnowledgeOwlType = {
  __typename?: 'LegacyKnowledgeOwlType'
  /** Knowledge Base Domain */
  domain: Scalars['String']
  /** OAuth Token */
  oauthToken: Scalars['String']
  /** Knowledge Base Project ID */
  projectId: Scalars['String']
}

export enum LegacyOrderSource {
  /** Orders from the Instacart Marketplace. */
  Marketplace = 'MARKETPLACE',
  /** Orders from a retailer via API. */
  Api = 'API',
  /** Orders from a Powered by Instacart whitelabel site. */
  Pbi = 'PBI',
  /** Orders from a Unata site. */
  Unata = 'UNATA',
}

/** Information about pagination in a connection. */
export type LegacyPageInfo = {
  __typename?: 'LegacyPageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>
}

export type LegacyPartnerType = {
  __typename?: 'LegacyPartnerType'
  /** The Partner's unique identifier  */
  id: Scalars['ID']
  /** The name of the Partner */
  name: Scalars['String']
  /** The associated Warehouses */
  warehouses: Array<LegacyWarehouseType>
}

export type LegacyPartnerUserType = {
  __typename?: 'LegacyPartnerUserType'
  /** The way the PartnerUser was created */
  createdVia: Maybe<Scalars['String']>
  /** The user's email */
  email: Scalars['String']
  /** The user's given name */
  firstName: Scalars['String']
  /** The user's list of enabled flippers */
  flippers: Array<Scalars['String']>
  /** The user's surname */
  lastName: Scalars['String']
  /** The Partners which can be accessed */
  partners: Array<LegacyPartnerType>
  /** The user's list of permissions */
  permissions: Array<Scalars['String']>
  /** The user's phone number */
  phone: Maybe<Scalars['String']>
  /** The user's list of roles */
  roles: Array<Scalars['String']>
  /** A unique external identifier for the PartnerUser */
  uuid: Scalars['ID']
  /** The Warehouses which can be accessed */
  warehouses: Array<LegacyWarehouseType>
}

export enum LegacyPickingLaborEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Full service shoppers */
  FullService = 'FULL_SERVICE',
  /** In store shoppers */
  Iss = 'ISS',
}

export type LegacyProducts = {
  __typename?: 'LegacyProducts'
  totalCount: Maybe<Scalars['BigInt']>
  totalPages: Maybe<Scalars['BigInt']>
  items: Maybe<Array<Maybe<Scalars['JSONObject']>>>
}

/** Autogenerated return type of RecurringShiftCreate */
export type LegacyRecurringShiftCreatePayload = {
  __typename?: 'LegacyRecurringShiftCreatePayload'
  /** The initial shifts generated from this recurrence. */
  generateShiftsResult: Maybe<Array<LegacyRecurringShiftsGenerateResultType>>
  /** The newly created recurring shift. */
  recurringShift: Maybe<LegacyRecurringShiftsRecurringShiftType>
}

/** Autogenerated return type of RecurringShiftDestroy */
export type LegacyRecurringShiftDestroyPayload = {
  __typename?: 'LegacyRecurringShiftDestroyPayload'
  /** The ID of the deleted recurring shift */
  deletedRecurringShiftId: Maybe<Scalars['ID']>
}

export type LegacyRecurringShiftsGenerateResultType = {
  __typename?: 'LegacyRecurringShiftsGenerateResultType'
  /** The date of the driver shift that we attempted to create */
  date: Scalars['LegacyDate']
  /** Any errors that prevented the driver shift from being created */
  errors: Maybe<Array<Scalars['String']>>
  /** Whether the driver shift was created successfully for the given day */
  success: Scalars['Boolean']
}

export type LegacyRecurringShiftsRecurringShiftType = {
  __typename?: 'LegacyRecurringShiftsRecurringShiftType'
  /** A list of dates on which we will not generate a shift from this recurring shift */
  excludeDates: Maybe<Array<Scalars['LegacyDate']>>
  /** The ID of the recurring shift */
  id: Scalars['ID']
  /** End hour of shift, in local time (0-23) */
  localEndsAtHour: Scalars['Int']
  /** Start hour of shift, in local time (0-23) */
  localStartsAtHour: Scalars['Int']
  /** The shift type of the recurring shift */
  shiftType: LegacyShift
}

/** Autogenerated return type of RecurringShiftUpdate */
export type LegacyRecurringShiftUpdatePayload = {
  __typename?: 'LegacyRecurringShiftUpdatePayload'
  /** The updated recurring shift. */
  recurringShift: Maybe<LegacyRecurringShiftsRecurringShiftType>
}

export type LegacySearchImpressionImageCoverageType = {
  __typename?: 'LegacySearchImpressionImageCoverageType'
  /** Array of datapoints associated to query */
  data: Array<LegacyTimeSeriesDatumType>
}

export type LegacySearchImpressionMissingImagesReportType = {
  __typename?: 'LegacySearchImpressionMissingImagesReportType'
  /** URL to generated missing images report */
  url: Scalars['String']
}

export enum LegacyShift {
  /** Responsible for bringing completed orders to the customer's car. */
  Runner = 'RUNNER',
  /** Responsible for picking and purchasing items in the store. */
  PickingOnly = 'PICKING_ONLY',
  /** Responsible for shopping and delivery. */
  FullService = 'FULL_SERVICE',
}

export enum LegacyShopperStateEnum {
  /** Active */
  Active = 'ACTIVE',
  /** Resigned (deactivated) */
  Resigned = 'RESIGNED',
}

export type LegacyShopperType = {
  __typename?: 'LegacyShopperType'
  /** The shopper's email */
  email: Scalars['String']
  /** The shopper's given name */
  firstName: Scalars['String']
  /** Unique identifier */
  id: Scalars['ID']
  /** The shopper's surname */
  lastName: Scalars['String']
  /** The shoppers's phone number */
  phone: Scalars['String']
  /** The shopper's status */
  state: LegacyShopperStateEnum
}

/** The connection type for ShopperType. */
export type LegacyShopperTypeConnection = {
  __typename?: 'LegacyShopperTypeConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<LegacyShopperTypeEdge>>>
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<LegacyShopperType>>>
  /** Information to aid in pagination. */
  pageInfo: LegacyPageInfo
}

/** An edge in a connection. */
export type LegacyShopperTypeEdge = {
  __typename?: 'LegacyShopperTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<LegacyShopperType>
}

export type LegacyTimeSeriesDatumType = {
  __typename?: 'LegacyTimeSeriesDatumType'
  /** Date associated to value */
  x: Scalars['LegacyDate']
  /** Value associated to date */
  y: Scalars['Float']
}

export type LegacyTopItemsResultType = {
  __typename?: 'LegacyTopItemsResultType'
  /** A list of top items */
  topItems: Array<LegacyTopItemsType>
  /** Total number of results */
  totalCount: Scalars['Int']
}

export type LegacyTopItemsType = {
  __typename?: 'LegacyTopItemsType'
  /** Availability of the product, denoted as percentage */
  availabilityPercentage: Scalars['Float']
  /** Name of the department the product belongs to */
  department: Scalars['String']
  /** How often an item was found, denoted as percentage */
  foundRatePercentage: Scalars['Float']
  /** Total GMV for the product */
  gmv: Scalars['Float']
  /** Unique identifier */
  id: Scalars['ID']
  /** The image url for the product */
  imageUrl: Scalars['String']
  /** Total number of items this ordered for this product */
  orderedItems: Scalars['Int']
  /** The product's name */
  productName: Scalars['String']
  /** How often an item was refunded, denoted as percentage */
  refundRatePercentage: Scalars['Float']
}

export type LegacyWarehouseLocationConfigType = {
  __typename?: 'LegacyWarehouseLocationConfigType'
  /** Hybrid Picking setting for the Warehouse Location indicates combined ISS and Partner Pick */
  hybridPickingEnabled: Maybe<Scalars['Boolean']>
}

export type LegacyWarehouseLocationType = {
  __typename?: 'LegacyWarehouseLocationType'
  /** The active status for the warehouse location */
  active: Scalars['Boolean']
  /** The city */
  city: Maybe<Scalars['String']>
  /** Configuration Settings for this Warehouse Location */
  configValues: Maybe<LegacyWarehouseLocationConfigType>
  /** The delivery hours of the Warehouse Location */
  deliveryHours: Array<LegacyDeliveryHoursType>
  /** The pickup model handoff labor */
  fulfillmentMethods: Maybe<Array<LegacyFulfillmentMethodEnum>>
  /** The unique ID */
  id: Scalars['ID']
  /** The retailer-assigned location code */
  locationCode: Maybe<Scalars['String']>
  /** The name */
  name: Maybe<Scalars['String']>
  /** Identifies if the location does partner run alcohol delivery */
  partnerAlcoholDelivery: Scalars['Boolean']
  /** The pickup model picking labor */
  pickingLabor: Maybe<LegacyPickingLaborEnum>
  /** Identifies if pickup is enabled */
  pickup: Scalars['Boolean']
  /** The associated shoppers */
  shoppers: Array<LegacyShopperType>
  /** The associated shoppers collection */
  shoppersCollection: LegacyShopperTypeConnection
  /** The state */
  state: Maybe<Scalars['String']>
  /** The street (including street #) */
  street: Maybe<Scalars['String']>
  /** The associated Warehouse */
  warehouse: LegacyWarehouseType
  /** The zip code or postal code */
  zipCode: Maybe<Scalars['String']>
  /** The zip_plus_four */
  zipPlusFour: Maybe<Scalars['String']>
  /** The zones of the Warehouse Location */
  zones: Array<LegacyZoneType>
}

export type LegacyWarehouseLocationTypeDeliveryHoursArgs = {
  dates: Array<Scalars['LegacyDate']>
}

export type LegacyWarehouseLocationTypeShoppersArgs = {
  states?: Maybe<Array<LegacyShopperStateEnum>>
}

export type LegacyWarehouseLocationTypeShoppersCollectionArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  states?: Maybe<Array<LegacyShopperStateEnum>>
}

export type LegacyWarehouseLogoType = {
  __typename?: 'LegacyWarehouseLogoType'
  /** A header-specific version of the logo */
  header: Maybe<LegacyBaseImageType>
  /** A tiny version of the logo */
  tiny: Maybe<LegacyBaseImageType>
  /** The image url */
  url: Maybe<Scalars['String']>
  /** The whitelabeled logo */
  whiteLabelLandingPage: Maybe<LegacyBaseImageType>
}

export type LegacyWarehouseType = {
  __typename?: 'LegacyWarehouseType'
  /** Country of Warehouse */
  country: Maybe<LegacyCountryType>
  /** Warehouse early picking hour [if one is set] */
  earlyPickingHour: Maybe<Scalars['Int']>
  /** The warehouse's list of enabled flippers */
  flippers: Array<Scalars['String']>
  /** The Warehouse's unique identifier */
  id: Scalars['ID']
  /** The associated inactive WarehouseLocations */
  inactiveWarehouseLocations: Maybe<Array<LegacyWarehouseLocationType>>
  /** The Warehouses' logo */
  logo: Maybe<LegacyWarehouseLogoType>
  /** The name of the Warehouse */
  name: Maybe<Scalars['String']>
  /** The warehouse's order sources. */
  orderSources: Maybe<Array<LegacyOrderSource>>
  /** The associated Partner */
  partner: Maybe<LegacyPartnerType>
  /** The associated active WarehouseLocations */
  warehouseLocations: Maybe<Array<LegacyWarehouseLocationType>>
}

export type LegacyZoneType = {
  __typename?: 'LegacyZoneType'
  /** The unique identifier */
  id: Scalars['ID']
}

export type LogoWithTextBanner = {
  __typename?: 'LogoWithTextBanner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  imageUrl: Maybe<Scalars['String']>
  imageMobileUrl: Maybe<Scalars['String']>
  imageAltText: Maybe<Scalars['String']>
  backgroundColorHex: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
}

export type LogoWithTextBannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  ctaAction?: Maybe<BannerActionInput>
  imageUrl?: Maybe<Scalars['String']>
  imageMobileUrl?: Maybe<Scalars['String']>
  imageAltText?: Maybe<Scalars['String']>
  backgroundColorHex?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
}

export type MetricThresholdInput = {
  metricType?: Maybe<MetricType>
  threshold?: Maybe<Scalars['BigInt']>
}

export enum MetricType {
  Default = 'DEFAULT',
  ScheduledHours = 'SCHEDULED_HOURS',
  RecommendedHours = 'RECOMMENDED_HOURS',
  ScheduledGaps = 'SCHEDULED_GAPS',
  StaffingRate = 'STAFFING_RATE',
  MatchRate = 'MATCH_RATE',
  UtilizationRate = 'UTILIZATION_RATE',
  FiveHourAvailabilityRate = 'FIVE_HOUR_AVAILABILITY_RATE',
  FulfilledOrders = 'FULFILLED_ORDERS',
  DedicatedMatchRate = 'DEDICATED_MATCH_RATE',
  DedicatedUtilizationRate = 'DEDICATED_UTILIZATION_RATE',
}

export type MinimumPlatformVersionInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum
  /** Version used for the check */
  version: Scalars['String']
}

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionCreate */
export type MinimumPlatformVersionVisibilityConditionCreatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionCreatePayload'
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion
}

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionUpdate */
export type MinimumPlatformVersionVisibilityConditionUpdatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionUpdatePayload'
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion
}

export type Mutation = {
  __typename?: 'Mutation'
  contentManagementServiceCreatePlacement: Maybe<CreatePlacementResponse>
  apiIntegrationsServiceUpdateApiSetting: Maybe<UpdateApiSettingResponse>
  apiIntegrationsServiceDeleteApiSetting: Maybe<DeleteApiSettingResponse>
  orderServiceCancelOrder: Maybe<CancelOrderResponse>
  orderServiceRescheduleOrder: Maybe<RescheduleOrderResponse>
  /** Update an existing callback configuration */
  callbackConfigurationUpdate: Maybe<PartnerCallbackConfigurationUpdatePayload>
  /** Create a new catalog 'code lookup batch' and add the given codes to it */
  catalogCodeLookupBatchCreate: Maybe<CatalogCodeLookupBatchCreatePayload>
  /** Create a new catalog 'code lookup' import process and add the given codes to it */
  catalogImportProcessCodeLookupCreate: Maybe<CatalogImportProcessCodeLookupCreatePayload>
  /** Create a new catalog workflow */
  catalogWorkflowCreate: Maybe<CatalogWorkflowCreatePayload>
  /** Delete an existing workflow (only workflows in the `draft` state can be deleted) */
  catalogWorkflowDelete: Maybe<CatalogWorkflowDeletePayload>
  /** Create a new catalog workflow */
  catalogWorkflowEventCreate: Maybe<CatalogWorkflowEventCreatePayload>
  /** Create a new 'BulkRemoveChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveChangesetNewProductRequests: Maybe<CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload>
  /** Create a new 'BulkRemoveChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveChangesetProducts: Maybe<CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload>
  /** Create a new 'BulkRemoveImportProcessCodeLookups' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveImportProcessCodeLookups: Maybe<CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload>
  /** Create a new 'BulkUpdateChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkUpdateChangesetProducts: Maybe<CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload>
  /** Submit a workflow to the catalog */
  catalogWorkflowSubmit: Maybe<CatalogWorkflowSubmitPayload>
  /** Create a new collection */
  collectionCreate: Maybe<CollectionCreatePayload>
  /** Delete an existing collection */
  collectionDelete: Maybe<CollectionDeletePayload>
  /** Update an existing collection */
  collectionUpdate: Maybe<CollectionUpdatePayload>
  /** Set up a new account using an account setup token */
  enterpriseAccountAccountSetup: Maybe<EnterpriseAccountAccountSetupPayload>
  /** Authenticate an account using an email and password */
  enterpriseAccountAuthenticateEmailPassword: Maybe<EnterpriseAccountAuthenticateEmailPasswordPayload>
  /** Preflight authentication info per email address */
  enterpriseAccountAuthenticatePreflight: Maybe<EnterpriseAccountAuthenticatePreflightPayload>
  /** Create a new enterprise account */
  enterpriseAccountCreate: Maybe<EnterpriseAccountCreatePayload>
  /** Request that an account setup email be sent to an Account's email address */
  enterpriseAccountRequestAccountSetupEmail: Maybe<EnterpriseAccountRequestAccountSetupEmailPayload>
  /** Request that a verification email be sent to an Account's email address */
  enterpriseAccountRequestEmailVerification: Maybe<EnterpriseAccountRequestEmailVerificationPayload>
  /** Request that a password reset email be sent to an Account's email address */
  enterpriseAccountRequestPasswordReset: Maybe<EnterpriseAccountRequestPasswordResetPayload>
  /** Set/Reset an account's password using a password reset token */
  enterpriseAccountResetPassword: Maybe<EnterpriseAccountResetPasswordPayload>
  /** Sets the disabled flag on an account to true/false */
  enterpriseAccountSetDisabled: Maybe<EnterpriseAccountSetDisabledPayload>
  /** Sign up for an account using an email */
  enterpriseAccountSignUpEmailPassword: Maybe<EnterpriseAccountSignUpEmailPasswordPayload>
  /** Update an enterprise account */
  enterpriseAccountUpdate: Maybe<EnterpriseAccountUpdatePayload>
  /** Verify an account's email using a verification token */
  enterpriseAccountVerifyEmail: Maybe<EnterpriseAccountVerifyEmailPayload>
  /** Create a ExpressMembership visibility condition */
  expressMembershipVisibilityConditionCreate: Maybe<ExpressMembershipVisibilityConditionCreatePayload>
  /** Update an existing ExpressMembership visibility condition */
  expressMembershipVisibilityConditionUpdate: Maybe<ExpressMembershipVisibilityConditionUpdatePayload>
  /** Create an ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityConditionCreate: Maybe<ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload>
  /** Create a new home placement with HeroBanner banner */
  heroBannerPlacementCreate: Maybe<HeroBannerPlacementCreatePayload>
  /** Update an existing hero_banner placement placement */
  heroBannerPlacementUpdate: Maybe<HeroBannerPlacementUpdatePayload>
  /** Create a new home placement with ImageForwardFlex banner */
  imageForwardFlexPlacementCreate: Maybe<ImageForwardFlexPlacementCreatePayload>
  /** Update an existing image_forward_flex placement placement */
  imageForwardFlexPlacementUpdate: Maybe<ImageForwardFlexPlacementUpdatePayload>
  /** Create a new home placement */
  imageForwardPlacementCreate: Maybe<ImageForwardPlacementCreatePayload>
  /** Update an existing image_forward placement placement */
  imageForwardPlacementUpdate: Maybe<ImageForwardPlacementUpdatePayload>
  /** Create a MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionCreate: Maybe<MinimumPlatformVersionVisibilityConditionCreatePayload>
  /** Update an existing MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionUpdate: Maybe<MinimumPlatformVersionVisibilityConditionUpdatePayload>
  /** Merges two or more normalized-reports by combining their contents into one file */
  normalizedReportsMerge: Maybe<NormalizedReportsMergePayload>
  /** Subscribe an account to a notification type for a retailer */
  notificationSubscriptionCreate: Maybe<NotificationSubscriptionCreatePayload>
  /** Unsubscribe an account to a notification type for a retailer */
  notificationSubscriptionDelete: Maybe<NotificationSubscriptionDeletePayload>
  /** Sends a test callback for a partner */
  partnerCallbackCreate: Maybe<PartnerCallbackCreatePayload>
  /** Create a new partner pick device */
  partnerPickDeviceCreate: Maybe<PartnerPickDeviceCreatePayload>
  /** Update an existing partner pick device's status */
  partnerPickDeviceSetStatus: Maybe<PartnerPickDeviceSetStatusPayload>
  /** Update an existing partner pick device */
  partnerPickDeviceUpdate: Maybe<PartnerPickDeviceUpdatePayload>
  /** Create a new partner pick recurring shift */
  partnerPickRecurringShiftCreate: Maybe<PartnerPickRecurringShiftCreatePayload>
  /** Delete a partner pick recurring shift by id, from some date onward */
  partnerPickRecurringShiftDelete: Maybe<PartnerPickRecurringShiftDeletePayload>
  /** Update an existing partner pick recurring shift */
  partnerPickRecurringShiftUpdate: Maybe<PartnerPickRecurringShiftUpdatePayload>
  /** Create a new report request */
  reportRequestCreate: Maybe<ReportRequestCreatePayload>
  /** Create a new retailer location group */
  retailerLocationGroupCreate: Maybe<RetailerLocationGroupCreatePayload>
  /** Delete an existing retailer location group */
  retailerLocationGroupDelete: Maybe<RetailerLocationGroupDeletePayload>
  /** Update an existing retailer location group */
  retailerLocationGroupUpdate: Maybe<RetailerLocationGroupUpdatePayload>
  /** Simulate an event for an existing sandbox order */
  sandboxOrderSimulateEvent: Maybe<PartnerSandboxOrderSimulateEventPayload>
  /** Create a new home placement with SecondaryBanner banner */
  secondaryBannerPlacementCreate: Maybe<SecondaryBannerPlacementCreatePayload>
  /** Update an existing secondary_banner placement placement */
  secondaryBannerPlacementUpdate: Maybe<SecondaryBannerPlacementUpdatePayload>
  /** Create a ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionCreate: Maybe<ShoppedAtRetailerVisibilityConditionCreatePayload>
  /** Update an existing ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionUpdate: Maybe<ShoppedAtRetailerVisibilityConditionUpdatePayload>
  /** Create a new storefront placement */
  storefrontPlacementCreate: Maybe<StorefrontPlacementCreatePayload>
  /** Delete an existing storefront placement */
  storefrontPlacementDelete: Maybe<StorefrontPlacementDeletePayload>
  /** Update an existing storefront placement placement */
  storefrontPlacementUpdate: Maybe<StorefrontPlacementUpdatePayload>
  /** Create a new TextWithThumbnailFlex home placement */
  textWithThumbnailFlexPlacementCreate: Maybe<TextWithThumbnailFlexPlacementCreatePayload>
  /** Update an existing text_with_thumbnail_flex placement placement */
  textWithThumbnailFlexPlacementUpdate: Maybe<TextWithThumbnailFlexPlacementUpdatePayload>
  /** Create a new home placement */
  textWithThumbnailPlacementCreate: Maybe<TextWithThumbnailPlacementCreatePayload>
  /** Update an existing text_with_thumbnail placement placement */
  textWithThumbnailPlacementUpdate: Maybe<TextWithThumbnailPlacementUpdatePayload>
  /** Delete an existing visibility condition */
  visibilityConditionDelete: Maybe<VisibilityConditionDeletePayload>
  /** Create a WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionCreate: Maybe<WhitelistedPostalCodesVisibilityConditionCreatePayload>
  /** Update an existing WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionUpdate: Maybe<WhitelistedPostalCodesVisibilityConditionUpdatePayload>
  /** Create a Recurring Shift from an existing Driver Shift */
  legacyRecurringShiftCreate: Maybe<LegacyRecurringShiftCreatePayload>
  /** Destroy a Recurring Shift */
  legacyRecurringShiftDestroy: Maybe<LegacyRecurringShiftDestroyPayload>
  /** Update a Recurring Shift */
  legacyRecurringShiftUpdate: Maybe<LegacyRecurringShiftUpdatePayload>
}

export type MutationContentManagementServiceCreatePlacementArgs = {
  input?: Maybe<CreatePlacementRequestInput>
}

export type MutationApiIntegrationsServiceUpdateApiSettingArgs = {
  input?: Maybe<UpdateApiSettingRequestInput>
}

export type MutationApiIntegrationsServiceDeleteApiSettingArgs = {
  input?: Maybe<DeleteApiSettingRequestInput>
}

export type MutationOrderServiceCancelOrderArgs = {
  input?: Maybe<CancelOrderRequestInput>
}

export type MutationOrderServiceRescheduleOrderArgs = {
  input?: Maybe<RescheduleOrderRequestInput>
}

export type MutationCallbackConfigurationUpdateArgs = {
  id: Scalars['ID']
  updatedCallbackConfiguration: CallbackConfigurationInput
}

export type MutationCatalogCodeLookupBatchCreateArgs = {
  codeLookupsData: Array<CodeLookupDataInput>
}

export type MutationCatalogImportProcessCodeLookupCreateArgs = {
  workflowId: Scalars['ID']
  codeLookupsData: Array<ImportProcessCodeLookupDataInput>
  codeLookupType: ImportProcessCodeLookupTypeEnum
  source?: Maybe<Scalars['String']>
}

export type MutationCatalogWorkflowCreateArgs = {
  retailerId: Scalars['ID']
  workflowType: WorkflowTypeEnum
}

export type MutationCatalogWorkflowDeleteArgs = {
  id: Scalars['ID']
}

export type MutationCatalogWorkflowEventCreateArgs = {
  workflowId: Scalars['ID']
  workflowEventCreationInput: WorkflowEventCreationInput
}

export type MutationCatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsArgs = {
  workflowId: Scalars['ID']
  changesetNewProductRequestIdsFilter?: Maybe<Array<Scalars['ID']>>
  aisleIdFilter?: Maybe<Scalars['ID']>
  departmentIdFilter?: Maybe<Scalars['ID']>
  classifiedCodeFilter?: Maybe<Scalars['String']>
}

export type MutationCatalogWorkflowEventCreateBulkRemoveChangesetProductsArgs = {
  workflowId: Scalars['ID']
  changesetProductIdsFilter?: Maybe<Array<Scalars['ID']>>
  aisleIdFilter?: Maybe<Scalars['ID']>
  departmentIdFilter?: Maybe<Scalars['ID']>
  classifiedCodeFilter?: Maybe<Scalars['String']>
  statusFilter?: Maybe<ChangesetProductStatusEnum>
}

export type MutationCatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsArgs = {
  workflowId: Scalars['ID']
  importProcessIdFilter?: Maybe<Scalars['ID']>
  importProcessCodeLookupIdsFilter?: Maybe<Array<Scalars['ID']>>
  importProcessCodeLookupTypeFilter?: Maybe<ImportProcessCodeLookupTypeEnum>
  importProcessCodeLookupStateFilter?: Maybe<ImportProcessCodeLookupStateEnum>
  importProcessCodeLookupStatusFilter?: Maybe<ImportProcessCodeLookupStatusEnum>
  hasAssociatedNewProductRequestFilter?: Maybe<Scalars['Boolean']>
}

export type MutationCatalogWorkflowEventCreateBulkUpdateChangesetProductsArgs = {
  workflowId: Scalars['ID']
  changesetProductIdsFilter?: Maybe<Array<Scalars['ID']>>
  aisleIdFilter?: Maybe<Scalars['ID']>
  departmentIdFilter?: Maybe<Scalars['ID']>
  classifiedCodeFilter?: Maybe<Scalars['String']>
  statusFilter?: Maybe<ChangesetProductStatusEnum>
  updatedAisleId?: Maybe<Scalars['ID']>
  updatedDepartmentId?: Maybe<Scalars['ID']>
  updatedCostUnit?: Maybe<CostUnitEnum>
  updatedPricePerCostUnit?: Maybe<Scalars['Float']>
}

export type MutationCatalogWorkflowSubmitArgs = {
  workflowId: Scalars['ID']
}

export type MutationCollectionCreateArgs = {
  collectionName: Scalars['String']
  startDate?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['String']>
  parentId?: Maybe<Scalars['ID']>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  collectionType: CollectionTypeEnum
  active?: Maybe<Scalars['Boolean']>
  activeAdminOnly?: Maybe<Scalars['Boolean']>
  image?: Maybe<Scalars['String']>
  childrenIds?: Maybe<Array<Scalars['ID']>>
  headerData?: Maybe<CollectionHeaderInput>
  storefrontBannerData?: Maybe<CollectionStorefrontBannerInput>
  subjectsData?: Maybe<Array<CollectionSubjectInput>>
}

export type MutationCollectionDeleteArgs = {
  collectionId: Scalars['ID']
}

export type MutationCollectionUpdateArgs = {
  collectionId: Scalars['ID']
  collectionName?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['String']>
  parentId?: Maybe<Scalars['ID']>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  collectionType?: Maybe<CollectionTypeEnum>
  active?: Maybe<Scalars['Boolean']>
  activeAdminOnly?: Maybe<Scalars['Boolean']>
  image?: Maybe<Scalars['String']>
  childrenIds?: Maybe<Array<Scalars['ID']>>
  headerData?: Maybe<CollectionHeaderInput>
  storefrontBannerData?: Maybe<CollectionStorefrontBannerInput>
  subjectsData?: Maybe<Array<CollectionSubjectInput>>
}

export type MutationEnterpriseAccountAccountSetupArgs = {
  rawToken: Scalars['String']
  password: Scalars['String']
  givenName?: Maybe<Scalars['String']>
  surname?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
}

export type MutationEnterpriseAccountAuthenticateEmailPasswordArgs = {
  email: Scalars['String']
  password: Scalars['String']
  reCaptchaToken?: Maybe<Scalars['String']>
}

export type MutationEnterpriseAccountAuthenticatePreflightArgs = {
  email: Scalars['String']
}

export type MutationEnterpriseAccountCreateArgs = {
  givenName: Scalars['String']
  surname: Scalars['String']
  phone?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  roleIds: Array<Scalars['ID']>
  partnerIds: Array<Scalars['ID']>
  retailerIds: Array<Scalars['ID']>
  retailerLocationIds: Array<Scalars['ID']>
  hasAllPartnersFullAccess: Scalars['Boolean']
  hasFullPartnerAccess: Scalars['Boolean']
  hasFullRetailerAccess: Scalars['Boolean']
  email: Scalars['String']
}

export type MutationEnterpriseAccountRequestAccountSetupEmailArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountRequestEmailVerificationArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountRequestPasswordResetArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountResetPasswordArgs = {
  rawToken: Scalars['String']
  password: Scalars['String']
}

export type MutationEnterpriseAccountSetDisabledArgs = {
  accountCanonicalId: Scalars['ID']
  value: Scalars['Boolean']
}

export type MutationEnterpriseAccountSignUpEmailPasswordArgs = {
  email: Scalars['String']
  password: Scalars['String']
  givenName?: Maybe<Scalars['String']>
  surname?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountUpdateArgs = {
  givenName: Scalars['String']
  surname: Scalars['String']
  phone?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  roleIds: Array<Scalars['ID']>
  partnerIds: Array<Scalars['ID']>
  retailerIds: Array<Scalars['ID']>
  retailerLocationIds: Array<Scalars['ID']>
  hasAllPartnersFullAccess: Scalars['Boolean']
  hasFullPartnerAccess: Scalars['Boolean']
  hasFullRetailerAccess: Scalars['Boolean']
  canonicalId: Scalars['ID']
}

export type MutationEnterpriseAccountVerifyEmailArgs = {
  rawToken: Scalars['String']
}

export type MutationExpressMembershipVisibilityConditionCreateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput
}

export type MutationExpressMembershipVisibilityConditionUpdateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput
}

export type MutationExpressNonmemberLongTermHoldoutVisibilityConditionCreateArgs = {
  expressNonmemberLongTermHoldoutVisibilityConditionData: ExpressNonmemberLongTermHoldoutInput
}

export type MutationHeroBannerPlacementCreateArgs = {
  heroBannerPlacementData: HeroBannerPlacementInput
}

export type MutationHeroBannerPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  heroBannerPlacementData: HeroBannerPlacementInput
}

export type MutationImageForwardFlexPlacementCreateArgs = {
  imageForwardFlexPlacementData: ImageForwardFlexPlacementInput
}

export type MutationImageForwardFlexPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  imageForwardFlexPlacementData: ImageForwardFlexPlacementInput
}

export type MutationImageForwardPlacementCreateArgs = {
  imageForwardPlacementData: ImageForwardPlacementInput
}

export type MutationImageForwardPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  imageForwardPlacementData: ImageForwardPlacementInput
}

export type MutationMinimumPlatformVersionVisibilityConditionCreateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput
}

export type MutationMinimumPlatformVersionVisibilityConditionUpdateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput
}

export type MutationNormalizedReportsMergeArgs = {
  partnerId: Scalars['ID']
  retailerId: Scalars['ID']
  startDate: Scalars['ISO8601Date']
  endDate?: Maybe<Scalars['ISO8601Date']>
  reportType: ReportTypeEnum
}

export type MutationNotificationSubscriptionCreateArgs = {
  retailerId: Scalars['ID']
  accountId: Scalars['ID']
  notificationTypeId: Scalars['ID']
}

export type MutationNotificationSubscriptionDeleteArgs = {
  retailerId: Scalars['ID']
  accountId: Scalars['ID']
  notificationTypeId: Scalars['ID']
}

export type MutationPartnerCallbackCreateArgs = {
  partnerId: Scalars['ID']
  orderId: Scalars['String']
  event: Scalars['String']
}

export type MutationPartnerPickDeviceCreateArgs = {
  warehouseLocationId: Scalars['ID']
  deviceType: DeviceTypeEnum
  firstName: Scalars['String']
  lastName: Scalars['String']
  email: Scalars['String']
  phone?: Maybe<Scalars['String']>
  password?: Maybe<Scalars['String']>
  isPartnerPickStoreManager: Scalars['Boolean']
}

export type MutationPartnerPickDeviceSetStatusArgs = {
  id: Scalars['ID']
  active: Scalars['Boolean']
}

export type MutationPartnerPickDeviceUpdateArgs = {
  id: Scalars['ID']
  deviceType?: Maybe<DeviceTypeEnum>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  password?: Maybe<Scalars['String']>
  isPartnerPickStoreManager?: Maybe<Scalars['Boolean']>
}

export type MutationPartnerPickRecurringShiftCreateArgs = {
  driverId: Scalars['ID']
  warehouseLocationId: Scalars['ID']
  shiftType: ShiftTypeEnum
  daysOfWeek: Array<Scalars['Int']>
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftLengthSeconds: Scalars['Int']
  recurStartDate: Scalars['String']
  recurEndDate?: Maybe<Scalars['String']>
  onCall?: Maybe<Scalars['Boolean']>
}

export type MutationPartnerPickRecurringShiftDeleteArgs = {
  id: Scalars['ID']
  deleteShiftsFromDate: Scalars['String']
}

export type MutationPartnerPickRecurringShiftUpdateArgs = {
  id: Scalars['ID']
  daysOfWeek?: Maybe<Array<Scalars['Int']>>
  shiftStartSecondsSinceMidnight?: Maybe<Scalars['Int']>
  shiftLengthSeconds?: Maybe<Scalars['Int']>
  recurStartDate?: Maybe<Scalars['String']>
  recurEndDate?: Maybe<Scalars['String']>
  onCall?: Maybe<Scalars['Boolean']>
}

export type MutationReportRequestCreateArgs = {
  name: Scalars['String']
  reportId: Scalars['ID']
  associatedObjectId: Scalars['ID']
  associatedObjectType: ReportRequestAssociatedObjectTypeEnum
  filters?: Maybe<ReportFilters>
}

export type MutationRetailerLocationGroupCreateArgs = {
  name: Scalars['String']
  retailerId: Scalars['ID']
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
}

export type MutationRetailerLocationGroupDeleteArgs = {
  id: Scalars['ID']
}

export type MutationRetailerLocationGroupUpdateArgs = {
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
}

export type MutationSandboxOrderSimulateEventArgs = {
  orderId: Scalars['String']
  partnerId: Scalars['String']
  simulationEvent: Scalars['String']
  simulationEventArgs?: Maybe<Array<Scalars['String']>>
  callbackEvent?: Maybe<Scalars['String']>
}

export type MutationSecondaryBannerPlacementCreateArgs = {
  secondaryBannerPlacementData: SecondaryBannerPlacementInput
}

export type MutationSecondaryBannerPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  secondaryBannerPlacementData: SecondaryBannerPlacementInput
}

export type MutationShoppedAtRetailerVisibilityConditionCreateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput
}

export type MutationShoppedAtRetailerVisibilityConditionUpdateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput
}

export type MutationStorefrontPlacementCreateArgs = {
  retailerId: Scalars['ID']
  storefrontPlacementData: StorefrontPlacementInput
}

export type MutationStorefrontPlacementDeleteArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
}

export type MutationStorefrontPlacementUpdateArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
  bannerId: Scalars['ID']
  storefrontPlacementData: StorefrontPlacementInput
}

export type MutationTextWithThumbnailFlexPlacementCreateArgs = {
  textWithThumbnailFlexPlacementData: TextWithThumbnailFlexPlacementInput
}

export type MutationTextWithThumbnailFlexPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  textWithThumbnailFlexPlacementData: TextWithThumbnailFlexPlacementInput
}

export type MutationTextWithThumbnailPlacementCreateArgs = {
  textWithThumbnailPlacementData: TextWithThumbnailPlacementInput
}

export type MutationTextWithThumbnailPlacementUpdateArgs = {
  id: Scalars['ID']
  bannerId: Scalars['ID']
  textWithThumbnailPlacementData: TextWithThumbnailPlacementInput
}

export type MutationVisibilityConditionDeleteArgs = {
  id: Scalars['ID']
}

export type MutationWhitelistedPostalCodesVisibilityConditionCreateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput
}

export type MutationWhitelistedPostalCodesVisibilityConditionUpdateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput
}

export type MutationLegacyRecurringShiftCreateArgs = {
  shopperShiftId: Scalars['ID']
}

export type MutationLegacyRecurringShiftDestroyArgs = {
  recurringShiftId: Scalars['ID']
  deleteShiftsFromDate: Scalars['LegacyDate']
}

export type MutationLegacyRecurringShiftUpdateArgs = {
  recurringShiftId: Scalars['ID']
  localStartsAtHour: Scalars['Int']
  localEndsAtHour: Scalars['Int']
  shiftStartSecondsSinceMidnight?: Maybe<Scalars['Int']>
  shiftLengthSeconds?: Maybe<Scalars['Int']>
}

export type NavigateToCategorySurface = {
  __typename?: 'NavigateToCategorySurface'
  categorySurfaceType: Maybe<CategorySurfaceType>
}

export type NavigateToCategorySurfaceInput = {
  categorySurfaceType?: Maybe<CategorySurfaceType>
}

export type NavigateToCollection = {
  __typename?: 'NavigateToCollection'
  slug: Maybe<Scalars['String']>
  legacyPath: Maybe<Scalars['String']>
}

export type NavigateToCollectionHub = {
  __typename?: 'NavigateToCollectionHub'
  category: Maybe<Scalars['String']>
}

export type NavigateToCollectionHubInput = {
  category?: Maybe<Scalars['String']>
}

export type NavigateToCollectionInput = {
  slug?: Maybe<Scalars['String']>
  legacyPath?: Maybe<Scalars['String']>
}

export type NavigateToContainerPathViaStoreSelector = {
  __typename?: 'NavigateToContainerPathViaStoreSelector'
  retailers: Maybe<Array<Maybe<RetailerContainerPath>>>
}

export type NavigateToContainerPathViaStoreSelectorInput = {
  retailers?: Maybe<Array<Maybe<RetailerContainerPathInput>>>
}

export type NavigateToDepartment = {
  __typename?: 'NavigateToDepartment'
  departmentId: Maybe<Scalars['BigInt']>
}

export type NavigateToDepartmentInput = {
  departmentId?: Maybe<Scalars['BigInt']>
}

export type NavigateToPickupStoreSelector = {
  __typename?: 'NavigateToPickupStoreSelector'
  showDistance: Maybe<Scalars['Boolean']>
}

export type NavigateToPickupStoreSelectorInput = {
  showDistance?: Maybe<Scalars['Boolean']>
}

export type NavigateToProduct = {
  __typename?: 'NavigateToProduct'
  productId: Maybe<Scalars['BigInt']>
}

export type NavigateToProductInput = {
  productId?: Maybe<Scalars['BigInt']>
}

export type NavigateToPromoModal = {
  __typename?: 'NavigateToPromoModal'
  discountPolicyId: Maybe<Scalars['BigInt']>
}

export type NavigateToPromoModalInput = {
  discountPolicyId?: Maybe<Scalars['BigInt']>
}

export type NavigateToRetailerCollection = {
  __typename?: 'NavigateToRetailerCollection'
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
}

export type NavigateToRetailerCollectionInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  slug?: Maybe<Scalars['String']>
}

export type NavigateToRetailerCollectionViaStoreSelector = {
  __typename?: 'NavigateToRetailerCollectionViaStoreSelector'
  retailerCollections: Maybe<Array<Maybe<RetailerCollection>>>
}

export type NavigateToRetailerCollectionViaStoreSelectorInput = {
  retailerCollections?: Maybe<Array<Maybe<RetailerCollectionInput>>>
}

export type NavigateToSsaStoreSelector = {
  __typename?: 'NavigateToSsaStoreSelector'
  serviceAreaType: Maybe<Scalars['String']>
}

export type NavigateToSsaStoreSelectorInput = {
  serviceAreaType?: Maybe<Scalars['String']>
}

export type NavigateToStorefront = {
  __typename?: 'NavigateToStorefront'
  retailerId: Maybe<Scalars['BigInt']>
}

export type NavigateToStorefrontInput = {
  retailerId?: Maybe<Scalars['BigInt']>
}

export type NavigateToStoreSelector = {
  __typename?: 'NavigateToStoreSelector'
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type NavigateToStoreSelectorInput = {
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type NavigateToUrl = {
  __typename?: 'NavigateToUrl'
  url: Maybe<Scalars['String']>
  openInNewTab: Maybe<Scalars['Boolean']>
}

export type NavigateToUrlInput = {
  url?: Maybe<Scalars['String']>
  openInNewTab?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of NormalizedReportsMerge */
export type NormalizedReportsMergePayload = {
  __typename?: 'NormalizedReportsMergePayload'
  /** Merge successful */
  success: Scalars['Boolean']
}

export type NormalizedReportsNormalizedReport = {
  __typename?: 'NormalizedReportsNormalizedReport'
  /** Name of the bucket where the report comes from */
  bucketName: Scalars['String']
  /** Date at which the report was created in YYYY-MM-DD format */
  createdAt: Scalars['Time']
  /** Type of the file */
  fileType: Scalars['String']
  /** Name of the file */
  name: Scalars['String']
  /** Type of the report */
  reportType: ReportTypeEnum
  /** File path to the object in the bucket */
  s3Key: Scalars['String']
  /** Size in bytes of the object */
  size: Scalars['Int']
}

/** The connection type for NormalizedReportsNormalizedReport. */
export type NormalizedReportsNormalizedReportConnection = {
  __typename?: 'NormalizedReportsNormalizedReportConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NormalizedReportsNormalizedReportEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<NormalizedReportsNormalizedReport>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type NormalizedReportsNormalizedReportEdge = {
  __typename?: 'NormalizedReportsNormalizedReportEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<NormalizedReportsNormalizedReport>
}

export type NormalizedReportsNormalizedReportSignedUrl = {
  __typename?: 'NormalizedReportsNormalizedReportSignedUrl'
  /** Signed url for the object */
  signedUrl: Scalars['String']
}

export type NormalizedReportsReportType = {
  __typename?: 'NormalizedReportsReportType'
  /** Report type label */
  label: Scalars['String']
  /** The report type value */
  value: ReportTypeEnum
}

export type NotificationsNotificationType = {
  __typename?: 'NotificationsNotificationType'
  /** Description of notification type, ie: Inventory File Normalization */
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** If the user making the request is eligible to subscribe to this notification */
  isEligible: Scalars['Boolean']
  /** If the user making the request is subscribed to the notification type for the specified retailer */
  isSubscribed: Scalars['Boolean']
  /** Name of notification type, ie: Inventory File Normalization */
  name: Scalars['String']
}

export type NotificationsNotificationTypeAccount = {
  __typename?: 'NotificationsNotificationTypeAccount'
  /** Account ID of user */
  accountId: Scalars['ID']
  /** Email of user */
  email: Scalars['ID']
  /** Given name of user */
  givenName: Scalars['String']
  /** If the user is eligible to subscribe to this notification */
  isEligible: Scalars['Boolean']
  /** If the user is subscribed to the notification type for the specified retailer */
  isSubscribed: Scalars['Boolean']
  /** Surname of user */
  surname: Maybe<Scalars['String']>
}

/** Autogenerated return type of NotificationSubscriptionCreate */
export type NotificationSubscriptionCreatePayload = {
  __typename?: 'NotificationSubscriptionCreatePayload'
  /** Subsription successful */
  success: Scalars['Boolean']
}

/** Autogenerated return type of NotificationSubscriptionDelete */
export type NotificationSubscriptionDeletePayload = {
  __typename?: 'NotificationSubscriptionDeletePayload'
  /** Unsubscribe successful */
  success: Scalars['Boolean']
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>
}

export type Partner = {
  __typename?: 'Partner'
  /** The callback configurations belonging to this partner */
  callbackConfigurations: Maybe<Array<PartnerCallbackConfiguration>>
  /** The client configuration belonging to this partner if it exists */
  clientConfiguration: Maybe<PartnerClientConfiguration>
  /** A unique identifier for the partner */
  id: Scalars['ID']
  /** The name of the partner */
  name: Scalars['String']
  /** The retailers belonging to this partner */
  retailers: RetailerConnection
  /** A sandbox order belonging to the partner */
  sandboxOrder: Maybe<PartnerSandboxOrder>
}

export type PartnerRetailersArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type PartnerSandboxOrderArgs = {
  id: Scalars['String']
}

export type PartnerCallbackConfiguration = {
  __typename?: 'PartnerCallbackConfiguration'
  /** The access token TTL */
  accessTokenTtl: Scalars['Int']
  /** The authentication URI */
  authUri: Scalars['String']
  /** The possible statuses to enable */
  availableStatuses: Array<Scalars['String']>
  /** The callback URI */
  callbackUri: Scalars['String']
  /** The client id */
  credentialsClientId: Scalars['String']
  /** The client credentials_client_secret */
  credentialsClientSecret: Scalars['String']
  /** The environment that the configuration belongs to */
  environment: Scalars['String']
  /** A unique identifier for the callback configuration */
  id: Scalars['ID']
  /** The enabled statusers */
  statusesOfInterest: Array<Scalars['String']>
}

/** Autogenerated return type of PartnerCallbackConfigurationUpdate */
export type PartnerCallbackConfigurationUpdatePayload = {
  __typename?: 'PartnerCallbackConfigurationUpdatePayload'
  /** The updated callback configuration */
  callbackConfiguration: PartnerCallbackConfiguration
}

/** Autogenerated return type of PartnerCallbackCreate */
export type PartnerCallbackCreatePayload = {
  __typename?: 'PartnerCallbackCreatePayload'
  /** The response(s) from the callback */
  callbackResponse: Array<PartnerCallbackResponse>
}

export type PartnerCallbackResponse = {
  __typename?: 'PartnerCallbackResponse'
  /** The body that was sent */
  body: Scalars['String']
  /** The headers that were sent */
  headers: Scalars['String']
  /** The type of the notification log */
  logType: Scalars['String']
  /** The response body */
  responseBody: Scalars['String']
  /** The response code */
  responseCode: Scalars['String']
  /** The time when the callback was sent */
  timestamp: Scalars['String']
  /** The url the callback was sent to */
  url: Scalars['String']
}

export type PartnerClientConfiguration = {
  __typename?: 'PartnerClientConfiguration'
  /** Does the partner have access to project shield */
  accessProjectShield: Scalars['String']
}

/** The connection type for Partner. */
export type PartnerConnection = {
  __typename?: 'PartnerConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PartnerEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Partner>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PartnerEdge = {
  __typename?: 'PartnerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<Partner>
}

export type PartnerPickCapacityGetCapacityRecommendationsResponse = {
  __typename?: 'PartnerPickCapacityGetCapacityRecommendationsResponse'
  recommendations: Array<PartnerPickCapacityRecommendation>
}

export type PartnerPickCapacityRecommendation = {
  __typename?: 'PartnerPickCapacityRecommendation'
  date: Scalars['ISO8601Date']
  endsAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  recommendationType: RecommendationTypeEnum
  retailerLocationId: Scalars['ID']
  shiftType: ShiftTypeEnum
  startsAt: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of PartnerPickDeviceCreate */
export type PartnerPickDeviceCreatePayload = {
  __typename?: 'PartnerPickDeviceCreatePayload'
  /** The newly created device */
  partnerPickDevice: PartnerPickDevicesDevice
}

export type PartnerPickDevicesDevice = {
  __typename?: 'PartnerPickDevicesDevice'
  /** Status for the device */
  active: Scalars['Boolean']
  /** Type of device */
  deviceType: DeviceTypeEnum
  /** Email address for the device */
  email: Scalars['String']
  /** First name for the device */
  firstName: Scalars['String']
  /** A unique identifier for the device */
  id: Scalars['ID']
  /** Whether the device belongs to a store manager */
  isPartnerPickStoreManager: Scalars['Boolean']
  /** Last name for the device */
  lastName: Scalars['String']
  /** Phone number for the device */
  phone: Scalars['String']
}

export type PartnerPickDevicesDeviceSearch = {
  __typename?: 'PartnerPickDevicesDeviceSearch'
  devices: Array<PartnerPickDevicesDevice>
  meta: HubPaginationMeta
}

/** Autogenerated return type of PartnerPickDeviceSetStatus */
export type PartnerPickDeviceSetStatusPayload = {
  __typename?: 'PartnerPickDeviceSetStatusPayload'
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice
}

/** Autogenerated return type of PartnerPickDeviceUpdate */
export type PartnerPickDeviceUpdatePayload = {
  __typename?: 'PartnerPickDeviceUpdatePayload'
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice
}

/** Autogenerated return type of PartnerPickRecurringShiftCreate */
export type PartnerPickRecurringShiftCreatePayload = {
  __typename?: 'PartnerPickRecurringShiftCreatePayload'
  /** The newly created recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift
}

/** Autogenerated return type of PartnerPickRecurringShiftDelete */
export type PartnerPickRecurringShiftDeletePayload = {
  __typename?: 'PartnerPickRecurringShiftDeletePayload'
  errorMessage: Maybe<Scalars['String']>
  /** Whether the deletion succeeded or not */
  success: Scalars['True']
}

export type PartnerPickRecurringShiftsConflict = {
  __typename?: 'PartnerPickRecurringShiftsConflict'
  recurringShiftConflicts: Array<PartnerPickRecurringShiftsRecurringShiftConflict>
  singleShiftConflicts: Array<PartnerPickRecurringShiftsSingleShiftConflict>
}

export type PartnerPickRecurringShiftsRecurringShift = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShift'
  /** an array of Ruby Date wday that a shift recurs on (0-6, Sunday is zero) */
  daysOfWeek: Array<Scalars['Int']>
  driverId: Scalars['ID']
  driverShiftId: Maybe<Scalars['ID']>
  id: Scalars['ID']
  onCall: Maybe<Scalars['Boolean']>
  recurEndDate: Maybe<Scalars['ISO8601Date']>
  recurStartDate: Maybe<Scalars['ISO8601Date']>
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftType: ShiftTypeEnum
}

export type PartnerPickRecurringShiftsRecurringShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShiftConflict'
  /** Days of the week when a shift occurs, represented as an Int (0-6). Sunday is 0 */
  daysOfWeek: Array<Scalars['Int']>
  id: Scalars['ID']
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftType: ShiftTypeEnum
}

export type PartnerPickRecurringShiftsSingleShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsSingleShiftConflict'
  date: Scalars['ISO8601Date']
  endsAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  shiftType: ShiftTypeEnum
  startsAt: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of PartnerPickRecurringShiftUpdate */
export type PartnerPickRecurringShiftUpdatePayload = {
  __typename?: 'PartnerPickRecurringShiftUpdatePayload'
  /** The updated recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift
}

export type PartnerSandboxOrder = {
  __typename?: 'PartnerSandboxOrder'
  /** The logs from callback attempts for the sandbox order */
  callbackLogs: Maybe<Array<PartnerSandboxOrderCallbackLog>>
  /** Timestamp when the sandbox order was created */
  createdAt: Scalars['String']
  /** Timestamp when the sandbox order was delivered */
  deliveredAt: Maybe<Scalars['String']>
  /** A unique identifier for the sandbox order */
  id: Scalars['ID']
  /** Items within the sandbox order */
  items: Array<PartnerSandboxOrderItem>
  /** Events that can be simulated on this order */
  simulationEvents: Array<PartnerSandboxOrderSimulationEvent>
  /** The fulfillment status of the sandbox order */
  status: Scalars['String']
  /** Timestamp when the sandbox order delivery window ends */
  windowEndsAt: Scalars['String']
  /** Timestamp when the sandbox order delivery window starts */
  windowStartsAt: Scalars['String']
}

export type PartnerSandboxOrderCallbackLog = {
  __typename?: 'PartnerSandboxOrderCallbackLog'
  /** The event that the callback is for */
  event: Scalars['String']
  /** The response for the callback */
  logs: Maybe<Array<PartnerCallbackResponse>>
}

export type PartnerSandboxOrderItem = {
  __typename?: 'PartnerSandboxOrderItem'
  /** Retailer reference code to identify the item */
  itemRrc: Maybe<Scalars['String']>
  /** Universal product code to identify the item */
  itemUpc: Maybe<Scalars['String']>
  /** The unique line number decided by the partner */
  lineNum: Scalars['String']
  /** The quantity of items for the order */
  qty: Scalars['Float']
  /** The quantity unit the quantity value is in */
  qtyUnit: Scalars['String']
  /** Whether or not this item was replaced during fulfillment */
  replaced: Scalars['Boolean']
}

/** Autogenerated return type of PartnerSandboxOrderSimulateEvent */
export type PartnerSandboxOrderSimulateEventPayload = {
  __typename?: 'PartnerSandboxOrderSimulateEventPayload'
  /** The order that went through simulation */
  sandboxOrder: PartnerSandboxOrder
}

export type PartnerSandboxOrderSimulationEvent = {
  __typename?: 'PartnerSandboxOrderSimulationEvent'
  /** Arguments required when simulating this event */
  arguments: Array<Scalars['String']>
  /** The name of this simulation event */
  event: Scalars['String']
  /** The ID of the sandbox order these simulation events belong to */
  orderId: Scalars['String']
  /** The result when this event is simulated */
  outcome: PartnerSandboxOrderSimulationEventOutcome
}

export type PartnerSandboxOrderSimulationEventOutcome = {
  __typename?: 'PartnerSandboxOrderSimulationEventOutcome'
  /** A callback that will be triggered when the event is simulated */
  callback: Maybe<Scalars['String']>
  /** The status the order will be when the event is simulated */
  orderStatus: Scalars['String']
}

export enum PickingModelEnum {
  /** Partner managed */
  Retailer = 'RETAILER',
  /** Full service shoppers */
  FullService = 'FULL_SERVICE',
  /** In store shoppers */
  Iss = 'ISS',
}

export type Placement = {
  __typename?: 'Placement'
  id: Maybe<Scalars['BigInt']>
  platform: Maybe<Array<Maybe<PlatformType>>>
  startDate: Maybe<Scalars['DateTime']>
  endDate: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
  updatedAt: Maybe<Scalars['DateTime']>
  retailerId: Maybe<Scalars['BigInt']>
  type: Maybe<Scalars['String']>
  internalName: Maybe<Scalars['String']>
  banner: Maybe<BannerType>
  status: Maybe<Status>
  timezone: Maybe<Scalars['String']>
  layout: Maybe<Layout>
  teamOwner: Maybe<Scalars['String']>
  userOwner: Maybe<Scalars['BigInt']>
  rank: Maybe<Scalars['BigInt']>
  experimentName: Maybe<Scalars['String']>
  experimentVariant: Maybe<Scalars['String']>
  experimentMethod: Maybe<ExperimentMethod>
  enabled: Maybe<Scalars['Boolean']>
  banners: Maybe<Array<Maybe<BannerType>>>
}

export type PlacementDestinationInput = {
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String']
}

export enum PlacementDestinationTypeEnum {
  /** The placement links to an external url */
  External = 'EXTERNAL',
  /** The placement links to a product */
  Product = 'PRODUCT',
  /** The placement links to a collection */
  Collection = 'COLLECTION',
  /** The placement links to a collection hub */
  CollectionHub = 'COLLECTION_HUB',
  /** The placement links to a department */
  Department = 'DEPARTMENT',
  /** The placement links to a storefront */
  Storefront = 'STOREFRONT',
  /** The placement links to a store selector */
  StoreSelector = 'STORE_SELECTOR',
  /** The placement links to the pickup store selector */
  PickupStoreselector = 'PICKUP_STORESELECTOR',
  /** The placement links to the SSA store selector */
  SsaStoreselector = 'SSA_STORESELECTOR',
  /** The placement links to containers via a store selector */
  ContainerPathViaStoreSelector = 'CONTAINER_PATH_VIA_STORE_SELECTOR',
  /** The placement does not have an action */
  DoNotNavigate = 'DO_NOT_NAVIGATE',
  /** Unfamiliar Banner Action */
  Unknown = 'UNKNOWN',
}

export type PlacementExperimentInput = {
  /** Name of the Experiment */
  name: Scalars['String']
  /** Variant of the Experiment for which placement should be visible */
  variant: Scalars['String']
  /** Experiment Assignment or Lookup */
  accessMethod?: Maybe<PlacementExperimentMethodEnum>
}

export enum PlacementExperimentMethodEnum {
  /** Not specified */
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  /** Whether variant assignment should happen */
  Assign = 'ASSIGN',
  /** Whether a simple variant lookup should occur */
  Lookup = 'LOOKUP',
}

export type PlacementFilterInput = {
  /** A term to use to search for a placement */
  searchTerm?: Maybe<Scalars['String']>
  /** The platform(s) the placement is configured for (Eg. [MOBILE, WEB]) */
  platform?: Maybe<Array<PlacementPlatformEnum>>
  /** The current status of the placement (Eg. ACTIVE) */
  status?: Maybe<PlacementStatusEnum>
  /** The type of the placement (Eg. TEXT) */
  type?: Maybe<PlacementTypeEnum>
}

export type PlacementImagesInput = {
  /** The image url of the placement to display for large viewports */
  large: Scalars['Url']
  /** The image url of the placement to display for small viewports */
  small: Scalars['Url']
}

export type PlacementInput = {
  id?: Maybe<Scalars['BigInt']>
  platform?: Maybe<Array<Maybe<PlatformType>>>
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
  createdAt?: Maybe<Scalars['DateTime']>
  updatedAt?: Maybe<Scalars['DateTime']>
  retailerId?: Maybe<Scalars['BigInt']>
  type?: Maybe<Scalars['String']>
  internalName?: Maybe<Scalars['String']>
  banner?: Maybe<BannerTypeInput>
  status?: Maybe<Status>
  timezone?: Maybe<Scalars['String']>
  layout?: Maybe<Layout>
  teamOwner?: Maybe<Scalars['String']>
  userOwner?: Maybe<Scalars['BigInt']>
  rank?: Maybe<Scalars['BigInt']>
  experimentName?: Maybe<Scalars['String']>
  experimentVariant?: Maybe<Scalars['String']>
  experimentMethod?: Maybe<ExperimentMethod>
  enabled?: Maybe<Scalars['Boolean']>
  banners?: Maybe<Array<Maybe<BannerTypeInput>>>
}

export enum PlacementPlatformEnum {
  /** This placement should display on mobile */
  Mobile = 'MOBILE',
  /** This placement should display on web */
  Web = 'WEB',
  /** This placement should display on ios */
  Ios = 'IOS',
  /** This placement should display on android */
  Android = 'ANDROID',
}

export type PlacementScheduleInput = {
  /** When the placement should become active */
  startDate: Scalars['Time']
  /** When the placement should stop being active */
  endDate?: Maybe<Scalars['Time']>
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Scalars['String']
}

export type PlacementSortInput = {
  /** The field to sort on */
  field: PlacementSortInputFieldEnum
  /** The direction to sort */
  direction?: Maybe<PlacementSortInputDirectionEnum>
}

export enum PlacementSortInputDirectionEnum {
  /** Sort the results in ascending order */
  Asc = 'ASC',
  /** Sort the results in descending order */
  Desc = 'DESC',
}

export enum PlacementSortInputFieldEnum {
  /** Sort the results based on the status of the placement */
  Status = 'STATUS',
  /** Sort the results based on the status of the placement */
  CreatedAt = 'CREATED_AT',
}

export type PlacementsResponse = {
  __typename?: 'PlacementsResponse'
  placements: Maybe<Array<Maybe<Placement>>>
}

export enum PlacementStatusEnum {
  /** The placement is currently active */
  Active = 'ACTIVE',
  /** The placement is not currently active */
  Inactive = 'INACTIVE',
  /** The placement is currently the live banner */
  Live = 'LIVE',
}

export enum PlacementTypeEnum {
  /** This placement displays an image */
  Image = 'IMAGE',
  /** This placement displays text */
  Text = 'TEXT',
  /** This placement displays a TextWithThumbnail Home Announcement Banner */
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  /** This placement displays an ImageForward Home Announcement Banner */
  ImageForward = 'IMAGE_FORWARD',
  /** This placement displays an ImageForward Home Announcement Banner */
  Unknown = 'UNKNOWN',
  /** This placement displays a TextWithThumbnailFlex Home Announcement Banner */
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  /** This placement displays a ImageForwardFlex Home Announcement Banner */
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  /** This placement displays a HeroBanner Home Announcement Banner */
  HeroBanner = 'HERO_BANNER',
  /** This placement displays a SecondaryBanner Home Announcement Banner */
  SecondaryBanner = 'SECONDARY_BANNER',
}

export enum PlatformType {
  Web = 'WEB',
  Mobile = 'MOBILE',
  Ios = 'IOS',
  Android = 'ANDROID',
}

export type ProductCategoryTaxonomy = {
  __typename?: 'ProductCategoryTaxonomy'
  l1: Maybe<Scalars['String']>
  l2: Maybe<Scalars['String']>
  l3: Maybe<Scalars['String']>
  l4: Maybe<Scalars['String']>
  l5: Maybe<Scalars['String']>
  l6: Maybe<Scalars['String']>
}

export type Query = {
  __typename?: 'Query'
  storePerformanceServiceGetAggregatedStorePerformance: Maybe<StorePerformanceResponse>
  historicalStorePerformanceServiceGetAggregatedHistoricalStorePerformance: Maybe<HistoricalStorePerformanceResponse>
  contentManagementServiceGetPlacements: Maybe<PlacementsResponse>
  catalogToolsApiServiceGetRetailerProductData: Maybe<GetRetailerProductDataResponse>
  catalogToolsApiServiceGetLocalesByRetailer: Maybe<GetLocalesByRetailerResponse>
  catalogToolsApiServiceDownloadCatalogSearchResults: Maybe<DownloadCatalogSearchResultsResponse>
  apiIntegrationsServiceGetApiSettings: Maybe<GetApiSettingsResponse>
  apiIntegrationsServiceGetAuthenticationUrl: Maybe<GetAuthenticationUrlResponse>
  productsServiceGetLegacyElasticsearch: Maybe<LegacyElasticsearchResponse>
  productsServiceGetLegacyProducts: Maybe<LegacyProducts>
  retailerToolsServiceGetRetailerProducts: Maybe<GetRetailerProductsResponse>
  retailerToolsServiceGetItems: Maybe<GetItemsResponse>
  retailerToolsServiceGetCustomersContext: Maybe<GetCustomersContextResponse>
  orderServiceGetOrder: Maybe<GetOrderResponse>
  orderServiceGetDashboardOrder: Maybe<GetDashboardOrderResponse>
  orderServiceGetOrderLocation: Maybe<GetOrderLocationResponse>
  /** The access control details for the account */
  accessControlConfiguration: AccessControlConfiguration
  /** Check if an account token (reset password or verify email) is valid */
  accountTokenValidate: TokensValidation
  /** Fetch list of users eligible to subscribe to an event. Also indicates if they are currently subscribed. */
  accountsByNotificationType: Array<NotificationsNotificationTypeAccount>
  /** Retrieve a paginated list of top products */
  analyticsTopProducts: SnowflakeTopProductsResult
  /** Fetch a specific aisle by id */
  catalogAisle: CatalogAisle
  /** Fetch a specific catalog changeset new-product-request by id */
  catalogChangesetNewProductRequest: CatalogChangesetNewProductRequest
  /** Search for catalog changeset new-products-requests matching a set of criteria */
  catalogChangesetNewProductRequestSearch: CatalogChangesetNewProductRequestConnection
  /** Fetch a specific catalog changeset product by id */
  catalogChangesetProduct: CatalogChangesetProduct
  /** Search for catalog changeset products matching a set of criteria */
  catalogChangesetProductSearch: CatalogChangesetProductConnection
  /** Fetch a specific code lookup batch by id */
  catalogCodeLookupBatch: CatalogCodeLookupBatch
  /** Search for catalog code lookups matching a set of criteria */
  catalogCodeLookupSearch: CatalogCodeLookupConnection
  /** Fetch a specific department by id */
  catalogDepartment: CatalogDepartment
  /** Fetch a specific catalog import process by id */
  catalogImportProcess: CatalogImportProcess
  /** Fetch a specific catalog import process code-lookup by id */
  catalogImportProcessCodeLookup: CatalogImportProcessCodeLookup
  /** Search for catalog import process code lookups matching a set of criteria */
  catalogImportProcessCodeLookupSearch: CatalogImportProcessCodeLookupConnection
  /** Search for catalog import processes matching a set of criteria */
  catalogImportProcessSearch: CatalogImportProcessConnection
  /** Retrieve products by IDs */
  catalogProducts: Array<CatalogProduct>
  /** Retrieve a retailer-product by its ID */
  catalogRetailerProduct: CatalogRetailerProduct
  /** Search for retailer-products matching a set of criteria */
  catalogRetailerProductSearch: CatalogRetailerProductConnection
  /** Fetch a signed url for an S3 report */
  catalogSearchDownloadSignedUrl: CatalogSearchDownloadsCatalogSearchDownloadSignedUrl
  /** Fetch a specific catalog workflow by id */
  catalogWorkflow: CatalogWorkflow
  /** Search for catalog workflows matching a set of criteria */
  catalogWorkflowSearch: CatalogWorkflowConnection
  /** Fetch a specific collection by id */
  collection: CollectionsCollection
  /** Fetch a list of collections allowed to be a child */
  collectionChildrenSearch: CollectionsCollectionConnection
  /** Fetch a list of collections allowed to be a parent */
  collectionParentSearch: CollectionsCollectionConnection
  /** Fetch a list of collections */
  collectionSearch: CollectionsCollectionConnection
  /** The currently authenticated account */
  currentEnterpriseAccount: EnterpriseAccount
  /** Check if user has access to the given arguments */
  currentEnterpriseAccountAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck
  /** Fetch an EnterpriseAccount by its canonical id */
  enterpriseAccount: EnterpriseAccount
  /** Search for EnterpriseAccounts matching a set of criteria */
  enterpriseAccountSearch: EnterpriseAccountConnection
  /** Generate the sisense url */
  generateSisenseUrl: SisenseUrl
  /** Check the health of the server */
  healthCheck: HealthCheck
  /** Fetch a list of Marketplace Home placements */
  homePlacementSearch: Array<HomePlacement>
  /** Fetch a signed url for a single S3 report */
  normalizedReportSignedUrl: NormalizedReportsNormalizedReportSignedUrl
  /** Fetch a list of S3 report types */
  normalizedReportTypes: Array<NormalizedReportsReportType>
  /** Fetch a list of S3 reports */
  normalizedReportsSearch: NormalizedReportsNormalizedReportConnection
  /** Fetch list of notification types for a retailer */
  notificationTypesForCurrentAccountOnRetailer: Array<NotificationsNotificationType>
  /** Fetch a specific partner by id */
  partner: Partner
  /** Fetch a specific partner pick device by id */
  partnerPickDevice: PartnerPickDevicesDevice
  /** Fetch list of partner pick devices */
  partnerPickDeviceSearch: PartnerPickDevicesDeviceSearch
  /** Fetch capacity recommendations for a given retailer location and date */
  partnerPickGetCapacityRecommendations: PartnerPickCapacityGetCapacityRecommendationsResponse
  /** Check if recurring_shift being created will conflict with existing shifts */
  partnerPickRecurringShiftConflictCheck: PartnerPickRecurringShiftsConflict
  /** Search for partners matching a set of criteria */
  partnerSearch: PartnerConnection
  /** Retrieve pickup retailer location groups that belong to a specific retailer */
  pickupRetailerLocationGroup: Array<RetailersPickupRetailerLocationGroup>
  /** Retrieve a list of reports requested by the retailer */
  reportRequests: ReportsReportRequestConnection
  /** Retrieve a report view by report view id */
  reportView: ReportViewsInterface
  /** Retrieve a list of available reports to request */
  reports: Array<ReportsReport>
  /** Fetch a specific retailer by id */
  retailer: Retailer
  /** Fetch a specific retailer location by id */
  retailerLocation: RetailerLocation
  /** Retrieve a retailer location group by id */
  retailerLocationGroup: RetailersRetailerLocationGroup
  /** Retrieve retailer location groups that belong to a specific retailer */
  retailerLocationGroupsByRetailer: RetailersRetailerLocationGroupConnection
  /** Search for retailer locations matching a set of criteria */
  retailerLocationSearch: RetailerLocationConnection
  /** Search for retailer locations matching a set of criteria - returns an array instead of a connection type */
  retailerLocationSearchArray: Array<RetailerLocation>
  /** Search for retailers matching a set of criteria */
  retailerSearch: RetailerConnection
  /** Search for roles */
  roleSearch: Array<EnterpriseRole>
  /** Fetch a storefront placement by id */
  storefrontPlacement: ContentManagementStorefrontPlacement
  /** Fetch a list of storefront placements */
  storefrontPlacementSearch: ContentManagementStorefrontPlacementConnection
  /** Fetch taxonomy nodes */
  taxonomyNodes: Array<CatalogTaxonomyNode>
  /** Fetch visibility conditions */
  visibilityConditionSearch: Array<VisibilityCondition>
  /** Retrieve Configuration Information */
  legacyConfiguration: LegacyConfigurationType
  /** Retrieve the current partner user */
  legacyCurrentPartnerUser: LegacyPartnerUserType
  /** Check the health of the server */
  legacyHealthCheck: LegacyHealthCheckType
  /** Query a Partner by id */
  legacyPartner: LegacyPartnerType
  /** Query search impression image coverage */
  legacySearchImpressionImageCoverage: LegacySearchImpressionImageCoverageType
  /** Generate missing images report */
  legacySearchImpressionMissingImagesReport: LegacySearchImpressionMissingImagesReportType
  /** Retrieve a paginated list of top items */
  legacyTopItems: LegacyTopItemsResultType
  /** Query a Warehouse by id */
  legacyWarehouse: LegacyWarehouseType
  /** Query a WarehouseLocation by id */
  legacyWarehouseLocation: LegacyWarehouseLocationType
}

export type QueryStorePerformanceServiceGetAggregatedStorePerformanceArgs = {
  input?: Maybe<StorePerformanceRequestInput>
}

export type QueryHistoricalStorePerformanceServiceGetAggregatedHistoricalStorePerformanceArgs = {
  input?: Maybe<HistoricalStorePerformanceRequestInput>
}

export type QueryContentManagementServiceGetPlacementsArgs = {
  input?: Maybe<GetPlacementsRequestInput>
}

export type QueryCatalogToolsApiServiceGetRetailerProductDataArgs = {
  input?: Maybe<GetRetailerProductDataRequestInput>
}

export type QueryCatalogToolsApiServiceGetLocalesByRetailerArgs = {
  input?: Maybe<GetLocalesByRetailerRequestInput>
}

export type QueryCatalogToolsApiServiceDownloadCatalogSearchResultsArgs = {
  input?: Maybe<DownloadCatalogSearchResultsRequestInput>
}

export type QueryApiIntegrationsServiceGetApiSettingsArgs = {
  input?: Maybe<GetApiSettingsRequestInput>
}

export type QueryApiIntegrationsServiceGetAuthenticationUrlArgs = {
  input?: Maybe<GetAuthenticationUrlRequestInput>
}

export type QueryProductsServiceGetLegacyElasticsearchArgs = {
  input?: Maybe<GetLegacyElasticsearchRequestInput>
}

export type QueryProductsServiceGetLegacyProductsArgs = {
  input?: Maybe<GetLegacyProductsRequestInput>
}

export type QueryRetailerToolsServiceGetRetailerProductsArgs = {
  input?: Maybe<GetRetailerProductsRequestInput>
}

export type QueryRetailerToolsServiceGetItemsArgs = {
  input?: Maybe<GetItemsRequestInput>
}

export type QueryRetailerToolsServiceGetCustomersContextArgs = {
  input?: Maybe<GetCustomersContextRequestInput>
}

export type QueryOrderServiceGetOrderArgs = {
  input?: Maybe<GetOrderRequestInput>
}

export type QueryOrderServiceGetDashboardOrderArgs = {
  input?: Maybe<GetDashboardOrderRequestInput>
}

export type QueryOrderServiceGetOrderLocationArgs = {
  input?: Maybe<GetOrderLocationRequestInput>
}

export type QueryAccountTokenValidateArgs = {
  rawToken: Scalars['String']
  tokenType: TokenTypeEnum
}

export type QueryAccountsByNotificationTypeArgs = {
  retailerId: Scalars['ID']
  notificationTypeId: Scalars['ID']
  excludeInternalUsers?: Maybe<Scalars['Boolean']>
}

export type QueryAnalyticsTopProductsArgs = {
  retailerId: Scalars['ID']
  startAt?: Maybe<Scalars['ISO8601Date']>
  endAt?: Maybe<Scalars['ISO8601Date']>
  page?: Maybe<Scalars['Int']>
  limit?: Maybe<Scalars['Int']>
}

export type QueryCatalogAisleArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetNewProductRequestArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetNewProductRequestSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  aisleId?: Maybe<Scalars['ID']>
  departmentId?: Maybe<Scalars['ID']>
  classifiedCode?: Maybe<Scalars['String']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogChangesetProductArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetProductSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  aisleId?: Maybe<Scalars['ID']>
  departmentId?: Maybe<Scalars['ID']>
  classifiedCode?: Maybe<Scalars['String']>
  status?: Maybe<ChangesetProductStatusEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogCodeLookupBatchArgs = {
  id: Scalars['ID']
}

export type QueryCatalogCodeLookupSearchArgs = {
  batchId?: Maybe<Scalars['ID']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogDepartmentArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessCodeLookupArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessCodeLookupSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  importProcessId?: Maybe<Scalars['ID']>
  importProcessCodeLookupType?: Maybe<ImportProcessCodeLookupTypeEnum>
  importProcessCodeLookupState?: Maybe<ImportProcessCodeLookupStateEnum>
  importProcessCodeLookupStatus?: Maybe<ImportProcessCodeLookupStatusEnum>
  hasAssociatedNewProductRequest?: Maybe<Scalars['Boolean']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogImportProcessSearchArgs = {
  workflowId?: Maybe<Scalars['ID']>
  importProcessOwnerId?: Maybe<Scalars['ID']>
  importProcessType?: Maybe<ImportProcessTypeEnum>
  importProcessState?: Maybe<ImportProcessStateEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogProductsArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryCatalogRetailerProductArgs = {
  id: Scalars['ID']
}

export type QueryCatalogRetailerProductSearchArgs = {
  searchType: Scalars['String']
  searchTerm: Scalars['String']
  retailerId: Scalars['ID']
  available?: Maybe<Scalars['Boolean']>
  departmentIds?: Maybe<Array<Scalars['ID']>>
  aisleIds?: Maybe<Array<Scalars['ID']>>
  searchLimit?: Maybe<Scalars['Int']>
  localeCode?: Maybe<Scalars['String']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCatalogSearchDownloadSignedUrlArgs = {
  s3Key: Scalars['String']
}

export type QueryCatalogWorkflowArgs = {
  id: Scalars['ID']
}

export type QueryCatalogWorkflowSearchArgs = {
  retailerId?: Maybe<Scalars['ID']>
  workflowOwnerId?: Maybe<Scalars['ID']>
  workflowType?: Maybe<WorkflowTypeEnum>
  workflowStates?: Maybe<Array<WorkflowStateEnum>>
  workflowState?: Maybe<WorkflowStateEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCollectionArgs = {
  id: Scalars['ID']
  retailerId?: Maybe<Scalars['ID']>
}

export type QueryCollectionChildrenSearchArgs = {
  collectionId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  collectionName?: Maybe<Scalars['String']>
  active?: Maybe<Scalars['Boolean']>
  contentType?: Maybe<CollectionContentTypeEnum>
  collectionTypes: Array<CollectionTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCollectionParentSearchArgs = {
  collectionId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  collectionTypes: Array<CollectionTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCollectionSearchArgs = {
  retailerId?: Maybe<Scalars['ID']>
  collectionName?: Maybe<Scalars['String']>
  active?: Maybe<Scalars['Boolean']>
  contentType?: Maybe<CollectionContentTypeEnum>
  collectionTypes: Array<CollectionTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryCurrentEnterpriseAccountAuthorizationCheckArgs = {
  permissions?: Maybe<Array<Scalars['String']>>
  retailerIds?: Maybe<Array<Scalars['ID']>>
  partnerIds?: Maybe<Array<Scalars['ID']>>
  accountFlippers?: Maybe<Array<Scalars['String']>>
  requireWriteAccess?: Maybe<Scalars['Boolean']>
}

export type QueryEnterpriseAccountArgs = {
  canonicalId?: Maybe<Scalars['ID']>
}

export type QueryEnterpriseAccountSearchArgs = {
  email?: Maybe<Scalars['String']>
  roleId?: Maybe<Scalars['ID']>
  partnerId?: Maybe<Scalars['ID']>
  retailerId?: Maybe<Scalars['ID']>
  showDisabled?: Maybe<Scalars['Boolean']>
  canonicalIds?: Maybe<Array<Scalars['ID']>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryGenerateSisenseUrlArgs = {
  dashboardId: Scalars['String']
}

export type QueryHealthCheckArgs = {
  metricsToken?: Maybe<Scalars['String']>
}

export type QueryHomePlacementSearchArgs = {
  placementId?: Maybe<Scalars['ID']>
  sort?: Maybe<PlacementSortInput>
  filter?: Maybe<PlacementFilterInput>
}

export type QueryNormalizedReportSignedUrlArgs = {
  bucketName: Scalars['String']
  s3Key: Scalars['String']
}

export type QueryNormalizedReportTypesArgs = {
  partnerId: Scalars['ID']
}

export type QueryNormalizedReportsSearchArgs = {
  partnerId: Scalars['ID']
  retailerId: Scalars['ID']
  startDate: Scalars['ISO8601Date']
  endDate?: Maybe<Scalars['ISO8601Date']>
  reportType?: Maybe<ReportTypeEnum>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryNotificationTypesForCurrentAccountOnRetailerArgs = {
  retailerId: Scalars['ID']
}

export type QueryPartnerArgs = {
  id: Scalars['ID']
}

export type QueryPartnerPickDeviceArgs = {
  id: Scalars['ID']
}

export type QueryPartnerPickDeviceSearchArgs = {
  warehouseLocationId: Scalars['ID']
  active?: Maybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset: Scalars['Int']
}

export type QueryPartnerPickGetCapacityRecommendationsArgs = {
  retailerLocationId: Scalars['ID']
  date: Scalars['ISO8601Date']
}

export type QueryPartnerPickRecurringShiftConflictCheckArgs = {
  driverId: Scalars['ID']
  warehouseLocationId: Scalars['ID']
  daysOfWeek: Array<Scalars['Int']>
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftLengthSeconds: Scalars['Int']
  recurStartDate?: Maybe<Scalars['String']>
  recurEndDate?: Maybe<Scalars['String']>
  existingRecurringShiftId?: Maybe<Scalars['ID']>
  existingDriverShiftId?: Maybe<Scalars['ID']>
}

export type QueryPartnerSearchArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryPickupRetailerLocationGroupArgs = {
  retailerId: Scalars['ID']
  includeInactive?: Maybe<Scalars['Boolean']>
}

export type QueryReportRequestsArgs = {
  retailerId: Scalars['ID']
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryReportViewArgs = {
  reportViewId: Scalars['ID']
}

export type QueryRetailerArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationGroupArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationGroupsByRetailerArgs = {
  retailerId: Scalars['ID']
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryRetailerLocationSearchArgs = {
  retailerId?: Maybe<Scalars['ID']>
  pickup?: Maybe<Scalars['Boolean']>
  includeInactiveLocations?: Maybe<Scalars['Boolean']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryRetailerLocationSearchArrayArgs = {
  retailerId?: Maybe<Scalars['ID']>
  pickup?: Maybe<Scalars['Boolean']>
  includeInactiveLocations?: Maybe<Scalars['Boolean']>
}

export type QueryRetailerSearchArgs = {
  partnerId?: Maybe<Scalars['ID']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryStorefrontPlacementArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
}

export type QueryStorefrontPlacementSearchArgs = {
  retailerId: Scalars['ID']
  sort?: Maybe<PlacementSortInput>
  filter?: Maybe<PlacementFilterInput>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type QueryVisibilityConditionSearchArgs = {
  placementId?: Maybe<Scalars['ID']>
  visibilityConditionId?: Maybe<Scalars['ID']>
}

export type QueryLegacyPartnerArgs = {
  id: Scalars['ID']
}

export type QueryLegacySearchImpressionImageCoverageArgs = {
  startAt: Scalars['LegacyDate']
  endAt: Scalars['LegacyDate']
  warehouseId: Scalars['ID']
  storeGroupId?: Maybe<Scalars['ID']>
  warehouseLocationIds?: Maybe<Array<Scalars['ID']>>
}

export type QueryLegacySearchImpressionMissingImagesReportArgs = {
  warehouseId: Scalars['ID']
}

export type QueryLegacyTopItemsArgs = {
  warehouseId: Scalars['ID']
  page?: Maybe<Scalars['Int']>
  limit?: Maybe<Scalars['Int']>
}

export type QueryLegacyWarehouseArgs = {
  id: Scalars['ID']
}

export type QueryLegacyWarehouseLocationArgs = {
  id: Scalars['ID']
}

export enum RecommendationTypeEnum {
  DemandSurge = 'DEMAND_SURGE',
  Understaffed = 'UNDERSTAFFED',
  NoRunner = 'NO_RUNNER',
}

/** A report filter definition */
export type ReportFilterDefinitionsInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

/** Report Filters */
export type ReportFilters = {
  dateRange?: Maybe<DateRange>
  retailerLocations?: Maybe<RetailerLocations>
}

export enum ReportFilterTypeEnum {
  /** A filter that allows selection of a date range. */
  DateRange = 'DATE_RANGE',
  /** A filter that allows selection of a list of retailer locations. */
  RetailerLocations = 'RETAILER_LOCATIONS',
}

/** Report filter values */
export type ReportFilterValuesInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Identifier for this filter */
  slug: Scalars['String']
}

export enum ReportRequestAssociatedObjectTypeEnum {
  /** Retailer type of associated object */
  Retailer = 'Retailer',
}

/** Autogenerated return type of ReportRequestCreate */
export type ReportRequestCreatePayload = {
  __typename?: 'ReportRequestCreatePayload'
  /** The newly created report request */
  reportRequest: Maybe<ReportsReportRequest>
}

export enum ReportRequestStateEnum {
  /** A report request that is new and not yet processed */
  New = 'NEW',
  /** A report request that is currently being processed */
  InProgress = 'IN_PROGRESS',
  /** A report request that has been successfully processed */
  Complete = 'COMPLETE',
  /** A report request that has failed processing */
  Failed = 'FAILED',
}

export type ReportsReport = {
  __typename?: 'ReportsReport'
  /** The time at which the report was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the each report */
  id: Scalars['ID']
  /** A url-friendly ID for this report */
  slug: Scalars['String']
  supportedFilters: Array<ReportFilterDefinitionsInterface>
  /** The time at which the report was updated */
  updatedAt: Scalars['Time']
}

export type ReportsReportFilterDefinitionsDateRange = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsDateRange'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Maximum date allowed */
  maxDate: Scalars['ISO8601Date']
  /** Minimum date */
  minDate: Scalars['ISO8601Date']
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportFilterDefinitionsRetailerLocations = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsRetailerLocations'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportFilterValuesDateRange = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesDateRange'
  /** End date of date range */
  endDate: Scalars['ISO8601Date']
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Identifier for this filter */
  slug: Scalars['String']
  /** Start date of date range */
  startDate: Scalars['ISO8601Date']
}

export type ReportsReportFilterValuesRetailerLocations = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesRetailerLocations'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** A retailer location group ID */
  retailerLocationGroupId: Maybe<Scalars['ID']>
  /** A list of retailer location IDs */
  retailerLocationIds: Maybe<Array<Scalars['ID']>>
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportRequest = {
  __typename?: 'ReportsReportRequest'
  /** The time at which the report request was created */
  createdAt: Scalars['Time']
  enterpriseAccount: Maybe<EnterpriseAccount>
  /** The state the report request is currently in */
  generationState: ReportRequestStateEnum
  /** A unique identifier for the report request */
  id: Scalars['ID']
  /** The name of the report request */
  name: Scalars['String']
  report: ReportsReport
  reportFilters: Array<ReportFilterValuesInterface>
  reportViews: Array<ReportViewsInterface>
  /** The time at which the report request was updated */
  updatedAt: Scalars['Time']
}

/** The connection type for ReportsReportRequest. */
export type ReportsReportRequestConnection = {
  __typename?: 'ReportsReportRequestConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportsReportRequestEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ReportsReportRequest>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ReportsReportRequestEdge = {
  __typename?: 'ReportsReportRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<ReportsReportRequest>
}

export type ReportsReportViewsCsv = ReportViewsInterface & {
  __typename?: 'ReportsReportViewsCsv'
  /** download URL for the report view */
  downloadUrl: Maybe<Scalars['String']>
  /** A unique identifier for the report view */
  id: Scalars['ID']
}

export enum ReportTypeEnum {
  /** General weekly updates */
  WeeklyRetailerUpdate = 'WEEKLY_RETAILER_UPDATE',
  /** Out of stock items */
  OutOfStock = 'OUT_OF_STOCK',
  /** Order ratings */
  OrderRatings = 'ORDER_RATINGS',
  /** Top items */
  TopItems = 'TOP_ITEMS',
  /** Live Issue */
  LiveIssue = 'LIVE_ISSUE',
  /** Live Issue */
  UnataExpressWeekly = 'UNATA_EXPRESS_WEEKLY',
  /** Live Issue */
  RunnerHours = 'RUNNER_HOURS',
  /** Replacements and refunds */
  ReplacementsAndRefunds = 'REPLACEMENTS_AND_REFUNDS',
  /** Store level performance */
  StoreLevelPartnerPerformanceReport = 'STORE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Associate level performance */
  AssociateLevelPartnerPerformanceReport = 'ASSOCIATE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Monthly DLOG report */
  DlogMonthly = 'DLOG_MONTHLY',
  /** Monthly MLOG report */
  MlogMonthly = 'MLOG_MONTHLY',
  /** UUID Compliance */
  UuidCompliance = 'UUID_COMPLIANCE',
  /** Distribution System Report */
  DistributionSystemReport = 'DISTRIBUTION_SYSTEM_REPORT',
  /** Shopper Breaks */
  ShopperBreaks = 'SHOPPER_BREAKS',
  /** Retailer Pickup */
  RetailerPickup = 'RETAILER_PICKUP',
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
  /** Merged: Retailer Tax Logs */
  MergedRetailerTaxLogs = 'MERGED_RETAILER_TAX_LOGS',
  /** Merged: Taxes Paid at POS */
  MergedTaxesPaidAtPos = 'MERGED_TAXES_PAID_AT_POS',
}

/** A generated view of the report data */
export type ReportViewsInterface = {
  /** A unique identifier for the report view */
  id: Scalars['ID']
}

export type RescheduleOrderRequestInput = {
  requestContext?: Maybe<InstacartTypesV1RequestContextInput>
  userId?: Maybe<Scalars['BigInt']>
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
}

export type RescheduleOrderResponse = {
  __typename?: 'RescheduleOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

export type Retailer = {
  __typename?: 'Retailer'
  /** An array of the retailer's departments */
  departments: Array<CatalogDepartment>
  /** A url for header-specific version of the logo */
  headerLogoUrl: Maybe<Scalars['String']>
  /** A unique identifier for the retailer */
  id: Scalars['ID']
  /** Whether or not the retailer is on pbi */
  isPbi: Scalars['Boolean']
  /** The name of the retailer */
  name: Scalars['String']
  /** The partner that this retailer belongs to */
  partner: Partner
  /** The store configuration for the pbi retailer */
  pbiConfiguration: Maybe<ContentManagementPbiConfiguration>
  /** The locations belonging to this retailer */
  retailerLocations: RetailerLocationConnection
  /** The warehouse slug for a retailer */
  slug: Scalars['String']
  /** A url for tiny version of the logo */
  tinyLogoUrl: Maybe<Scalars['String']>
  /** A url for the white label landing page */
  whiteLabelLandingPageUrl: Maybe<Scalars['String']>
}

export type RetailerRetailerLocationsArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type RetailerCollection = {
  __typename?: 'RetailerCollection'
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
}

export type RetailerCollectionInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  slug?: Maybe<Scalars['String']>
}

/** The connection type for Retailer. */
export type RetailerConnection = {
  __typename?: 'RetailerConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Retailer>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RetailerContainerPath = {
  __typename?: 'RetailerContainerPath'
  retailerId: Maybe<Scalars['BigInt']>
  containerPath: Maybe<Scalars['String']>
}

export type RetailerContainerPathInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  containerPath?: Maybe<Scalars['String']>
}

/** An edge in a connection. */
export type RetailerEdge = {
  __typename?: 'RetailerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<Retailer>
}

export type RetailerLocale = {
  __typename?: 'RetailerLocale'
  retailerId: Maybe<Scalars['BigInt']>
  localeId: Maybe<Scalars['BigInt']>
  localeCode: Maybe<Scalars['String']>
}

export type RetailerLocation = {
  __typename?: 'RetailerLocation'
  /** The location's city */
  city: Maybe<Scalars['String']>
  /** Represents the set of 'Fullfillment Models' (how fulfillment is facilitated for the location) */
  fulfillmentModels: Maybe<Array<FulfillmentModelEnum>>
  /** A unique identifier for the retailer location */
  id: Scalars['ID']
  /** The retailer-assigned location code */
  locationCode: Maybe<Scalars['String']>
  /** The name of the retailer location */
  name: Maybe<Scalars['String']>
  /** Identifies if the location does partner run alcohol delivery */
  partnerAlcoholDelivery: Scalars['Boolean']
  /** Represents the 'Picking Model' (how picking is facilitated for the location) */
  pickingModel: Maybe<PickingModelEnum>
  /** A flag representing whether pickup is enabled */
  pickup: Scalars['Boolean']
  /** The retailer that this location belongs to */
  retailer: Retailer
  /** The location's state */
  state: Maybe<Scalars['String']>
  /** The location's street (including street #) */
  street: Maybe<Scalars['String']>
  /** The location's zip code or postal code */
  zipCode: Maybe<Scalars['String']>
  /** The location's ZIP+4 (US-specific) */
  zipPlusFour: Maybe<Scalars['String']>
}

/** The connection type for RetailerLocation. */
export type RetailerLocationConnection = {
  __typename?: 'RetailerLocationConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerLocationEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailerLocation>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type RetailerLocationEdge = {
  __typename?: 'RetailerLocationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<RetailerLocation>
}

/** Autogenerated return type of RetailerLocationGroupCreate */
export type RetailerLocationGroupCreatePayload = {
  __typename?: 'RetailerLocationGroupCreatePayload'
  /** The newly created group */
  retailerLocationGroup: RetailersRetailerLocationGroup
}

/** Autogenerated return type of RetailerLocationGroupDelete */
export type RetailerLocationGroupDeletePayload = {
  __typename?: 'RetailerLocationGroupDeletePayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of RetailerLocationGroupUpdate */
export type RetailerLocationGroupUpdatePayload = {
  __typename?: 'RetailerLocationGroupUpdatePayload'
  /** The updated group */
  retailerLocationGroup: RetailersRetailerLocationGroup
}

/** Attributes for a retailer location filter */
export type RetailerLocations = {
  /** A list of retailer location IDs */
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>
  /** A retailer location group ID */
  retailerLocationGroupId?: Maybe<Scalars['ID']>
}

export type RetailerProduct = {
  __typename?: 'RetailerProduct'
  aisles: Maybe<Array<Maybe<Aisle>>>
  alcoholic: Maybe<Scalars['Boolean']>
  brandId: Maybe<Scalars['BigInt']>
  brandName: Maybe<Scalars['String']>
  departments: Maybe<Array<Maybe<Department>>>
  details: Maybe<Scalars['String']>
  fatFree: Maybe<Scalars['Boolean']>
  glutenFree: Maybe<Scalars['Boolean']>
  hasImage: Maybe<Scalars['Boolean']>
  imageList: Maybe<Array<Maybe<ImageInfo>>>
  ingredients: Maybe<Scalars['String']>
  kosher: Maybe<Scalars['Boolean']>
  localeCode: Maybe<Scalars['String']>
  lowFat: Maybe<Scalars['Boolean']>
  organic: Maybe<Scalars['Boolean']>
  originalName: Maybe<Scalars['String']>
  primaryAisleId: Maybe<Scalars['BigInt']>
  primaryDepartmentId: Maybe<Scalars['BigInt']>
  primaryImageUrl: Maybe<Scalars['String']>
  productCategoryTaxonomy: Maybe<ProductCategoryTaxonomy>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productDisplayName: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  retailerReferenceCode: Maybe<Scalars['String']>
  score: Maybe<Scalars['Float']>
  seasonality: Maybe<Scalars['JSONObject']>
  size: Maybe<Scalars['String']>
  storeBrand: Maybe<Scalars['Boolean']>
  sugarFree: Maybe<Scalars['Boolean']>
  unitCount: Maybe<Scalars['BigInt']>
  vegan: Maybe<Scalars['Boolean']>
  vegetarian: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
}

export type RetailerProductData = {
  __typename?: 'RetailerProductData'
  retailerId: Maybe<Scalars['BigInt']>
  productId: Maybe<Scalars['BigInt']>
  maxPriceCents: Maybe<Scalars['BigInt']>
  minPriceCents: Maybe<Scalars['BigInt']>
  itemsCount: Maybe<Scalars['BigInt']>
  availableItemsCount: Maybe<Scalars['BigInt']>
  visibleItemsCount: Maybe<Scalars['BigInt']>
  generatedAt: Maybe<Scalars['DateTime']>
}

export type RetailerProductIdInput = {
  retailerId?: Maybe<Scalars['BigInt']>
  productId?: Maybe<Scalars['BigInt']>
}

export type RetailersPickupRetailerLocationGroup = {
  __typename?: 'RetailersPickupRetailerLocationGroup'
  /** A unique identifier for the location group */
  id: Scalars['ID']
  /** A name for this location group */
  name: Scalars['String']
  /** The identifier for the retailer which all locations in the group belong to */
  retailerId: Scalars['ID']
  /** The retailer locations associated with the group */
  retailerLocations: Array<RetailerLocation>
}

export type RetailersRetailerLocationGroup = {
  __typename?: 'RetailersRetailerLocationGroup'
  /** A unique identifier for the location group */
  id: Scalars['ID']
  /** A name for this location group */
  name: Scalars['String']
  /** The identifier for the retailer which all locations in the group belong to */
  retailerId: Scalars['ID']
  /** The ids for the retailer locations associated with the group */
  retailerLocationIds: Array<Scalars['ID']>
  /** The retailer locations associated with the group */
  retailerLocations: RetailerLocationConnection
  /** The time at which the group was last updated */
  updatedAt: Scalars['Time']
}

export type RetailersRetailerLocationGroupRetailerLocationsArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for RetailersRetailerLocationGroup. */
export type RetailersRetailerLocationGroupConnection = {
  __typename?: 'RetailersRetailerLocationGroupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailersRetailerLocationGroupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailersRetailerLocationGroup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type RetailersRetailerLocationGroupEdge = {
  __typename?: 'RetailersRetailerLocationGroupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<RetailersRetailerLocationGroup>
}

export type SecondaryBanner = {
  __typename?: 'SecondaryBanner'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  secondaryText: Maybe<Scalars['String']>
  secondaryTextColorHex: Maybe<Scalars['String']>
}

export type SecondaryBannerInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  mobileImageUrl?: Maybe<Scalars['String']>
  desktopImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
  secondaryText?: Maybe<Scalars['String']>
  secondaryTextColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of SecondaryBannerPlacementCreate */
export type SecondaryBannerPlacementCreatePayload = {
  __typename?: 'SecondaryBannerPlacementCreatePayload'
  /** The newly created secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement
}

export type SecondaryBannerPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: GenericImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The style and text of the secondary text */
  secondaryText?: Maybe<ConfigurableTextInput>
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of SecondaryBannerPlacementUpdate */
export type SecondaryBannerPlacementUpdatePayload = {
  __typename?: 'SecondaryBannerPlacementUpdatePayload'
  /** The updated secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement
}

export enum ShiftTypeEnum {
  PickingOnly = 'PICKING_ONLY',
  Runner = 'RUNNER',
  FullService = 'FULL_SERVICE',
}

export type ShoppedAtRetailerInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the Retailer */
  retailerId: Scalars['Int']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** Number of days in the past to check */
  numberOfDays?: Maybe<Scalars['Int']>
  /** Id of the country where the check is to be performed */
  countryId?: Maybe<Scalars['Int']>
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionCreate */
export type ShoppedAtRetailerVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionCreatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer
}

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionUpdate */
export type ShoppedAtRetailerVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionUpdatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer
}

export type SisenseUrl = {
  __typename?: 'SisenseUrl'
  /** Sisense url string */
  result: Scalars['Url']
}

export type SnowflakeTopProductsItem = {
  __typename?: 'SnowflakeTopProductsItem'
  /** Availability of the product, denoted as percentage */
  availabilityPercentage: Scalars['Float']
  /** Name of the department the product belongs to */
  department: Scalars['String']
  /** How often an item was found, denoted as percentage */
  foundRatePercentage: Scalars['Float']
  /** Total GMV for the product */
  gmv: Scalars['Float']
  /** Unique identifier */
  id: Scalars['ID']
  /** The image url for the product */
  imageUrl: Scalars['String']
  /** Total number of items this ordered for this product */
  orderedItems: Scalars['Int']
  /** The product's name */
  productName: Scalars['String']
  /** How often an item was refunded, denoted as percentage */
  refundRatePercentage: Scalars['Float']
}

export type SnowflakeTopProductsResult = {
  __typename?: 'SnowflakeTopProductsResult'
  /** A list of top items */
  topProducts: Array<SnowflakeTopProductsItem>
  /** Total number of results */
  totalCount: Scalars['Int']
}

export enum Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Live = 'LIVE',
}

export type StorefrontPlacementBannerInput = {
  /** A unique identifier of the banner associated with the placement */
  id?: Maybe<Scalars['ID']>
  /** The possible placement images to display */
  images: PlacementImagesInput
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The banner's locale (not used right now) */
  locale: BannerLocaleEnum
}

/** Autogenerated return type of StorefrontPlacementCreate */
export type StorefrontPlacementCreatePayload = {
  __typename?: 'StorefrontPlacementCreatePayload'
  /** The newly created storefront storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement
}

/** Autogenerated return type of StorefrontPlacementDelete */
export type StorefrontPlacementDeletePayload = {
  __typename?: 'StorefrontPlacementDeletePayload'
  /** Whether deleting the storefront placement succeeded or not */
  success: Scalars['Boolean']
}

export type StorefrontPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The possible placement images to display */
  images: PlacementImagesInput
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The banners configured to the placement */
  banners?: Maybe<Array<StorefrontPlacementBannerInput>>
}

/** Autogenerated return type of StorefrontPlacementUpdate */
export type StorefrontPlacementUpdatePayload = {
  __typename?: 'StorefrontPlacementUpdatePayload'
  /** The updated storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement
}

export type StorePerformanceRecord = {
  __typename?: 'StorePerformanceRecord'
  warehouseLocationId: Maybe<Scalars['BigInt']>
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>
  understaffedHours: Maybe<InstacartTypesV1BigDecimal>
  overstaffedHours: Maybe<InstacartTypesV1BigDecimal>
  scheduledGaps: Maybe<Scalars['Int']>
  scheduledDevices: Maybe<Scalars['Int']>
  name: Maybe<Scalars['String']>
}

export type StorePerformanceRequestInput = {
  warehouseLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
  warehouseId?: Maybe<Scalars['BigInt']>
}

export type StorePerformanceResponse = {
  __typename?: 'StorePerformanceResponse'
  warehouseId: Maybe<Scalars['BigInt']>
  updatedAt: Maybe<Scalars['DateTime']>
  metric: Maybe<Array<Maybe<StorePerformanceRecord>>>
}

export type TextWithThumbnail = {
  __typename?: 'TextWithThumbnail'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  backgroundImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
}

export type TextWithThumbnailFlex = {
  __typename?: 'TextWithThumbnailFlex'
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<BannerVariant>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  backgroundImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  ctaAction: Maybe<BannerAction>
  backgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
}

export type TextWithThumbnailFlexInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  backgroundImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of TextWithThumbnailFlexPlacementCreate */
export type TextWithThumbnailFlexPlacementCreatePayload = {
  __typename?: 'TextWithThumbnailFlexPlacementCreatePayload'
  /** The newly created text_with_thumbnail placement */
  textWithThumbnailFlexPlacement: ContentManagementTextWithThumbnailFlexPlacement
}

export type TextWithThumbnailFlexPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: TextWithThumbnailImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of TextWithThumbnailFlexPlacementUpdate */
export type TextWithThumbnailFlexPlacementUpdatePayload = {
  __typename?: 'TextWithThumbnailFlexPlacementUpdatePayload'
  /** The updated text_with_thumbnail_flex placement */
  textWithThumbnailFlexPlacement: ContentManagementTextWithThumbnailFlexPlacement
}

export type TextWithThumbnailImagesInput = {
  /** The image url of logo image */
  logo: Scalars['Url']
  /** The image url of the background image */
  background?: Maybe<Scalars['Url']>
}

export type TextWithThumbnailInput = {
  id?: Maybe<Scalars['BigInt']>
  variant?: Maybe<BannerVariant>
  title?: Maybe<Scalars['String']>
  titleColorHex?: Maybe<Scalars['String']>
  subTitle?: Maybe<Scalars['String']>
  subTitleColorHex?: Maybe<Scalars['String']>
  cta?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  backgroundImageUrl?: Maybe<Scalars['String']>
  placementId?: Maybe<Scalars['BigInt']>
  ctaAction?: Maybe<BannerActionInput>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaColorHex?: Maybe<Scalars['String']>
  ctaBackgroundColorHex?: Maybe<Scalars['String']>
}

/** Autogenerated return type of TextWithThumbnailPlacementCreate */
export type TextWithThumbnailPlacementCreatePayload = {
  __typename?: 'TextWithThumbnailPlacementCreatePayload'
  /** The newly created text_with_thumbnail placement */
  textWithThumbnailPlacement: ContentManagementTextWithThumbnailPlacement
}

export type TextWithThumbnailPlacementInput = {
  /** The name of the placement */
  name: Scalars['String']
  /** The images on the banner */
  images: TextWithThumbnailImagesInput
  /** Where interacting with the placement leads */
  destination?: Maybe<PlacementDestinationInput>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The priority rank of the placement */
  rank?: Maybe<Scalars['Int']>
  /** Information of Experiment associated with the placement */
  experiment?: Maybe<PlacementExperimentInput>
  enabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of TextWithThumbnailPlacementUpdate */
export type TextWithThumbnailPlacementUpdatePayload = {
  __typename?: 'TextWithThumbnailPlacementUpdatePayload'
  /** The updated text_with_thumbnail placement */
  textWithThumbnailPlacement: ContentManagementTextWithThumbnailPlacement
}

export type TokensValidation = {
  __typename?: 'TokensValidation'
  /** Whether the token is valid */
  valid: Scalars['Boolean']
}

export enum TokenTypeEnum {
  /** Email Verification Token Type */
  EmailVerification = 'email_verification',
  /** Password Reset Token Type */
  PasswordReset = 'password_reset',
}

export type UnknownBanner = {
  __typename?: 'UnknownBanner'
  id: Maybe<Scalars['BigInt']>
}

export type UnknownBannerInput = {
  id?: Maybe<Scalars['BigInt']>
}

export type UpdateApiSettingRequestInput = {
  id?: Maybe<Scalars['BigInt']>
  partnerId?: Maybe<Scalars['BigInt']>
  retailerId?: Maybe<Scalars['BigInt']>
  apiType?: Maybe<Scalars['String']>
  cron?: Maybe<Scalars['String']>
  integrationType?: Maybe<Scalars['String']>
  enabled?: Maybe<Scalars['Boolean']>
}

export type UpdateApiSettingResponse = {
  __typename?: 'UpdateApiSettingResponse'
  id: Maybe<Scalars['BigInt']>
  partnerId: Maybe<Scalars['BigInt']>
  apiType: Maybe<Scalars['String']>
  cron: Maybe<Scalars['String']>
  integrationType: Maybe<Scalars['String']>
  enabled: Maybe<Scalars['Boolean']>
}

/** Union of the Types of Visibility Conditions which may be returned */
export type VisibilityCondition =
  | ContentManagementVisibilityConditionExpressMembership
  | ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout
  | ContentManagementVisibilityConditionMinimumPlatformVersion
  | ContentManagementVisibilityConditionShoppedAtRetailer
  | ContentManagementVisibilityConditionWhitelistedPostalCodes

/** Autogenerated return type of VisibilityConditionDelete */
export type VisibilityConditionDeletePayload = {
  __typename?: 'VisibilityConditionDeletePayload'
  /** Whether deleting the visibility condition succeeded or not */
  success: Scalars['Boolean']
}

export type WhitelistedPostalCodesInput = {
  /** A unique identifier of the visibility condition */
  id?: Maybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>
}

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionCreate */
export type WhitelistedPostalCodesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionCreatePayload'
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes
}

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionUpdate */
export type WhitelistedPostalCodesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionUpdatePayload'
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes
}

/** Event type and payload [attributes] for creating a workflow event */
export type WorkflowEventCreationInput = {
  /** The kind of workflow event which should be created */
  workflowEventType: WorkflowEventTypeEnum
  /** The event payload attributes associated with this workflow event */
  workflowEventPayload: WorkflowEventPayloadInput
}

/** Payload attributes for creating a workflow event - note that this lists the allowed attributes for all event payloads */
export type WorkflowEventPayloadInput = {
  /** The id for the the product associated with this event */
  productId?: Maybe<Scalars['ID']>
  /** The id for the import process code-lookup associated with this event */
  importProcessCodeLookupId?: Maybe<Scalars['ID']>
  /** The id for the changeset product associated with this event */
  changesetProductId?: Maybe<Scalars['ID']>
  /** The id for the aisle that the product should be added to */
  aisleId?: Maybe<Scalars['ID']>
  /** The id for the department that the product should be added to */
  departmentId?: Maybe<Scalars['ID']>
  /** The cost unit which should be set for the product - (each, lb, ...) */
  costUnit?: Maybe<CostUnitEnum>
  /** The price which should be set for the product - (12.99) */
  pricePerCostUnit?: Maybe<Scalars['Float']>
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo?: Maybe<ClassificationInfoInput>
  /** The name which should be set for the product - `Hershey's Extra Large Chocolate Bar` */
  name?: Maybe<Scalars['String']>
  /** The brand which should be set for the product - `Hershey's` */
  brand?: Maybe<Scalars['String']>
  /** Details about the product, e.g. `Brown, overripe bananas, suitable for baking` */
  description?: Maybe<Scalars['String']>
  /** The size of the product - (`12 kg`, `14 oz`, ...) */
  size?: Maybe<Scalars['String']>
  /** Is the product taxable? - (true, false) */
  taxable?: Maybe<Scalars['Boolean']>
  /** Is the product alcoholic? - (true, false) */
  alcoholic?: Maybe<Scalars['Boolean']>
  /** Is the product kosher? - (true, false) */
  kosher?: Maybe<Scalars['Boolean']>
  /** Is the product sugar_free? - (true, false) */
  sugarFree?: Maybe<Scalars['Boolean']>
  /** Is the product fat_free? - (true, false) */
  fatFree?: Maybe<Scalars['Boolean']>
  /** Is the product low_fat? - (true, false) */
  lowFat?: Maybe<Scalars['Boolean']>
  /** Is the product vegan? - (true, false) */
  vegan?: Maybe<Scalars['Boolean']>
  /** Is the product gluten_free? - (true, false) */
  glutenFree?: Maybe<Scalars['Boolean']>
  /** Is the product organic? - (true, false) */
  organic?: Maybe<Scalars['Boolean']>
  /** Is the product vegetarian? - (true, false) */
  vegetarian?: Maybe<Scalars['Boolean']>
  /** An absolute url representing the 'primary' angle - `https://www.example.com/etc` */
  imageUrlPrimary?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'left' angle - `https://www.example.com/etc` */
  imageUrlLeft?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'right' angle - `https://www.example.com/etc` */
  imageUrlRight?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'back' angle - `https://www.example.com/etc` */
  imageUrlBack?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'top' angle - `https://www.example.com/etc` */
  imageUrlTop?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'ingredients' angle - `https://www.example.com/etc` */
  imageUrlIngredients?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'nutrition' angle - `https://www.example.com/etc` */
  imageUrlNutrition?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'supplement facts' angle - `https://www.example.com/etc` */
  imageUrlSupplementFacts?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'drug facts' angle - `https://www.example.com/etc` */
  imageUrlDrugFacts?: Maybe<Scalars['Url']>
  /** An absolute url representing the 'lifestyle' angle - `https://www.example.com/etc` */
  imageUrlLifestyle?: Maybe<Scalars['Url']>
}

export enum WorkflowEventTypeEnum {
  /** Import a product from the global catalog into our workflow */
  ImportGlobalProduct = 'IMPORT_GLOBAL_PRODUCT',
  /** Set the aisle for an imported changeset product */
  SetProductAisle = 'SET_PRODUCT_AISLE',
  /** Set the department for an imported changeset product */
  SetProductDepartment = 'SET_PRODUCT_DEPARTMENT',
  /** Set the cost unit for an imported changeset product - (each, lb, ...) */
  SetProductCostUnit = 'SET_PRODUCT_COST_UNIT',
  /** Set the price for an imported changeset product - (12.99) */
  SetProductPricePerCostUnit = 'SET_PRODUCT_PRICE_PER_COST_UNIT',
  /** Create or update a 'New-Product-Request' (A request to add a new product to Instacart's catalog) */
  UpsertNewProductRequest = 'UPSERT_NEW_PRODUCT_REQUEST',
}

export enum WorkflowStateEnum {
  /** A workflow that is currently in-progress, and is editable */
  Draft = 'DRAFT',
  /** A workflow that has been submitted, and is no longer editable */
  Submitted = 'SUBMITTED',
  /** A workflow that has been sent to the catalog successfully */
  Completed = 'COMPLETED',
  /** A workflow that has been sent to the catalog, with one or more items failing to imprt */
  CompletedWithError = 'COMPLETED_WITH_ERROR',
}

export enum WorkflowTypeEnum {
  /** An add-to-catalog type workflow */
  AddToCatalog = 'ADD_TO_CATALOG',
}

export type GetPickupAggregateHistoricalStorePerformanceMeshQueryVariables = {
  warehouseId: Scalars['BigInt']
  warehouseLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  metricThresholds?: Maybe<Array<Maybe<MetricThresholdInput>>>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
  devicePrioritizationEnabled?: Maybe<Scalars['Boolean']>
}

export type GetPickupAggregateHistoricalStorePerformanceMeshQuery = { __typename?: 'Query' } & {
  historicalStorePerformanceServiceGetAggregatedHistoricalStorePerformance: Maybe<
    { __typename?: 'HistoricalStorePerformanceResponse' } & Pick<
      HistoricalStorePerformanceResponse,
      'warehouseId' | 'updatedAt'
    > & {
        overviewMetrics: Maybe<
          Array<
            Maybe<
              { __typename?: 'HistoricalPerformanceOverviewRecord' } & Pick<
                HistoricalPerformanceOverviewRecord,
                'metricType'
              > & {
                  currentValue: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  pastValue: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                }
            >
          >
        >
        metrics: Maybe<
          Array<
            Maybe<
              { __typename?: 'HistoricalStorePerformanceRecord' } & Pick<
                HistoricalStorePerformanceRecord,
                | 'warehouseLocationId'
                | 'scheduledGaps'
                | 'partnerPickOrdersCount'
                | 'fssOrdersCount'
                | 'name'
              > & {
                  scheduledHours: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  recommendedHours: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  matchRate: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  utilizationRate: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  fiveHourAvailabilityRate: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  dedicatedMatchRate: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  dedicatedUtilizationRate: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                }
            >
          >
        >
      }
  >
}

export type GetPickupAggregatedStorePerformanceMeshQueryVariables = {
  warehouseId: Scalars['BigInt']
  warehouseLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>
  startDate?: Maybe<GoogleTypeDateInput>
  endDate?: Maybe<GoogleTypeDateInput>
}

export type GetPickupAggregatedStorePerformanceMeshQuery = { __typename?: 'Query' } & {
  storePerformanceServiceGetAggregatedStorePerformance: Maybe<
    { __typename?: 'StorePerformanceResponse' } & Pick<
      StorePerformanceResponse,
      'warehouseId' | 'updatedAt'
    > & {
        metric: Maybe<
          Array<
            Maybe<
              { __typename?: 'StorePerformanceRecord' } & Pick<
                StorePerformanceRecord,
                'warehouseLocationId' | 'scheduledGaps' | 'scheduledDevices' | 'name'
              > & {
                  scheduledHours: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  recommendedHours: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  understaffedHours: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                  overstaffedHours: Maybe<
                    { __typename?: 'InstacartTypesV1BigDecimal' } & Pick<
                      InstacartTypesV1BigDecimal,
                      'units' | 'nanos'
                    >
                  >
                }
            >
          >
        >
      }
  >
}

export type ListPickupStoreGroupsQueryVariables = {
  retailerId: Scalars['ID']
}

export type ListPickupStoreGroupsQuery = { __typename?: 'Query' } & {
  pickupRetailerLocationGroup: Array<
    { __typename?: 'RetailersPickupRetailerLocationGroup' } & Pick<
      RetailersPickupRetailerLocationGroup,
      'id' | 'name' | 'retailerId'
    > & {
        retailerLocations: Array<
          { __typename?: 'RetailerLocation' } & Pick<RetailerLocation, 'id' | 'name'>
        >
      }
  >
  retailerLocationSearchArray: Array<
    { __typename?: 'RetailerLocation' } & Pick<RetailerLocation, 'id' | 'name' | 'pickup'>
  >
}

export const GetPickupAggregateHistoricalStorePerformanceMeshDocument = gql`
  query getPickupAggregateHistoricalStorePerformanceMesh(
    $warehouseId: BigInt!
    $warehouseLocationIds: [BigInt]
    $metricThresholds: [MetricThresholdInput]
    $startDate: GoogleTypeDateInput
    $endDate: GoogleTypeDateInput
    $devicePrioritizationEnabled: Boolean
  ) {
    historicalStorePerformanceServiceGetAggregatedHistoricalStorePerformance(
      input: {
        metricThresholds: $metricThresholds
        warehouseLocationIds: $warehouseLocationIds
        warehouseId: $warehouseId
        startDate: $startDate
        endDate: $endDate
        devicePrioritizationEnabled: $devicePrioritizationEnabled
      }
    ) {
      warehouseId
      updatedAt
      overviewMetrics {
        metricType
        currentValue {
          units
          nanos
        }
        pastValue {
          units
          nanos
        }
      }
      metrics {
        warehouseLocationId
        scheduledHours {
          units
          nanos
        }
        recommendedHours {
          units
          nanos
        }
        scheduledGaps
        matchRate {
          units
          nanos
        }
        utilizationRate {
          units
          nanos
        }
        fiveHourAvailabilityRate {
          units
          nanos
        }
        partnerPickOrdersCount
        fssOrdersCount
        dedicatedMatchRate {
          units
          nanos
        }
        dedicatedUtilizationRate {
          units
          nanos
        }
        name
      }
    }
  }
`

/**
 * __useGetPickupAggregateHistoricalStorePerformanceMeshQuery__
 *
 * To run a query within a React component, call `useGetPickupAggregateHistoricalStorePerformanceMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickupAggregateHistoricalStorePerformanceMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickupAggregateHistoricalStorePerformanceMeshQuery({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *      warehouseLocationIds: // value for 'warehouseLocationIds'
 *      metricThresholds: // value for 'metricThresholds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      devicePrioritizationEnabled: // value for 'devicePrioritizationEnabled'
 *   },
 * });
 */
export function useGetPickupAggregateHistoricalStorePerformanceMeshQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPickupAggregateHistoricalStorePerformanceMeshQuery,
    GetPickupAggregateHistoricalStorePerformanceMeshQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetPickupAggregateHistoricalStorePerformanceMeshQuery,
    GetPickupAggregateHistoricalStorePerformanceMeshQueryVariables
  >(GetPickupAggregateHistoricalStorePerformanceMeshDocument, baseOptions)
}
export function useGetPickupAggregateHistoricalStorePerformanceMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPickupAggregateHistoricalStorePerformanceMeshQuery,
    GetPickupAggregateHistoricalStorePerformanceMeshQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetPickupAggregateHistoricalStorePerformanceMeshQuery,
    GetPickupAggregateHistoricalStorePerformanceMeshQueryVariables
  >(GetPickupAggregateHistoricalStorePerformanceMeshDocument, baseOptions)
}
export type GetPickupAggregateHistoricalStorePerformanceMeshQueryHookResult = ReturnType<
  typeof useGetPickupAggregateHistoricalStorePerformanceMeshQuery
>
export type GetPickupAggregateHistoricalStorePerformanceMeshLazyQueryHookResult = ReturnType<
  typeof useGetPickupAggregateHistoricalStorePerformanceMeshLazyQuery
>
export type GetPickupAggregateHistoricalStorePerformanceMeshQueryResult =
  ApolloReactCommon.QueryResult<
    GetPickupAggregateHistoricalStorePerformanceMeshQuery,
    GetPickupAggregateHistoricalStorePerformanceMeshQueryVariables
  >
export const GetPickupAggregatedStorePerformanceMeshDocument = gql`
  query getPickupAggregatedStorePerformanceMesh(
    $warehouseId: BigInt!
    $warehouseLocationIds: [BigInt]
    $startDate: GoogleTypeDateInput
    $endDate: GoogleTypeDateInput
  ) {
    storePerformanceServiceGetAggregatedStorePerformance(
      input: {
        warehouseLocationIds: $warehouseLocationIds
        warehouseId: $warehouseId
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      warehouseId
      updatedAt
      metric {
        warehouseLocationId
        scheduledGaps
        scheduledDevices
        name
        scheduledHours {
          units
          nanos
        }
        recommendedHours {
          units
          nanos
        }
        understaffedHours {
          units
          nanos
        }
        overstaffedHours {
          units
          nanos
        }
        overstaffedHours {
          units
          nanos
        }
      }
    }
  }
`

/**
 * __useGetPickupAggregatedStorePerformanceMeshQuery__
 *
 * To run a query within a React component, call `useGetPickupAggregatedStorePerformanceMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickupAggregatedStorePerformanceMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickupAggregatedStorePerformanceMeshQuery({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *      warehouseLocationIds: // value for 'warehouseLocationIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetPickupAggregatedStorePerformanceMeshQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPickupAggregatedStorePerformanceMeshQuery,
    GetPickupAggregatedStorePerformanceMeshQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetPickupAggregatedStorePerformanceMeshQuery,
    GetPickupAggregatedStorePerformanceMeshQueryVariables
  >(GetPickupAggregatedStorePerformanceMeshDocument, baseOptions)
}
export function useGetPickupAggregatedStorePerformanceMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPickupAggregatedStorePerformanceMeshQuery,
    GetPickupAggregatedStorePerformanceMeshQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetPickupAggregatedStorePerformanceMeshQuery,
    GetPickupAggregatedStorePerformanceMeshQueryVariables
  >(GetPickupAggregatedStorePerformanceMeshDocument, baseOptions)
}
export type GetPickupAggregatedStorePerformanceMeshQueryHookResult = ReturnType<
  typeof useGetPickupAggregatedStorePerformanceMeshQuery
>
export type GetPickupAggregatedStorePerformanceMeshLazyQueryHookResult = ReturnType<
  typeof useGetPickupAggregatedStorePerformanceMeshLazyQuery
>
export type GetPickupAggregatedStorePerformanceMeshQueryResult = ApolloReactCommon.QueryResult<
  GetPickupAggregatedStorePerformanceMeshQuery,
  GetPickupAggregatedStorePerformanceMeshQueryVariables
>
export const ListPickupStoreGroupsDocument = gql`
  query listPickupStoreGroups($retailerId: ID!) {
    pickupRetailerLocationGroup(retailerId: $retailerId) {
      id
      name
      retailerId
      retailerLocations {
        id
        name
      }
    }
    retailerLocationSearchArray(retailerId: $retailerId, pickup: true) {
      id
      name
      pickup
    }
  }
`

/**
 * __useListPickupStoreGroupsQuery__
 *
 * To run a query within a React component, call `useListPickupStoreGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPickupStoreGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPickupStoreGroupsQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useListPickupStoreGroupsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ListPickupStoreGroupsQuery,
    ListPickupStoreGroupsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<ListPickupStoreGroupsQuery, ListPickupStoreGroupsQueryVariables>(
    ListPickupStoreGroupsDocument,
    baseOptions
  )
}
export function useListPickupStoreGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListPickupStoreGroupsQuery,
    ListPickupStoreGroupsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    ListPickupStoreGroupsQuery,
    ListPickupStoreGroupsQueryVariables
  >(ListPickupStoreGroupsDocument, baseOptions)
}
export type ListPickupStoreGroupsQueryHookResult = ReturnType<typeof useListPickupStoreGroupsQuery>
export type ListPickupStoreGroupsLazyQueryHookResult = ReturnType<
  typeof useListPickupStoreGroupsLazyQuery
>
export type ListPickupStoreGroupsQueryResult = ApolloReactCommon.QueryResult<
  ListPickupStoreGroupsQuery,
  ListPickupStoreGroupsQueryVariables
>
